import React from 'react'
import {
    TrainingsOverviewMetaProps,
    AllocationsOverviewMetaProps,
    AdminHubMetaProps,
    AdminSettingsMetaProps,
    AdminTrainingsMetaProps,
    AreaFormModalMetaProps,
    AssignTrainingFormModalMetaProps,
    ConfirmationModalMetaProps,
    DeleteAreaMetaProps,
    DeleteDutyMetaProps,
    DeleteEventMetaProps,
    DeletePreferenceMetaProps,
    DeleteFlagMetaProps,
    DeleteShiftMetaProps,
    DocumentViewerMetaProps,
    DuplicateAreaModalMetaProps,
    DuplicateEventModalMetaProps,
    DutyCardMetaProps,
    DutyFormModalMetaProps,
    DutyMetaProps,
    EventCardMetaProps,
    EventDetailMetaProps,
    EventFormModalMetaProps,
    EventsMetaProps,
    FooterMetaProps,
    HeaderMetaProps,
    HomeMetaProps,
    LoadingSpinnerMetaProps,
    LoginMetaProps,
    Nav,
    PreferenceCardMetaProps,
    PreferenceFormModalMetaProps,
    PreferenceMetaProps,
    FlagCardMetaProps,
    FlagFormModalMetaProps,
    FlagMetaProps,
    FlagCategoryFormModalMetaProps,
    UpdateFlagCategoryFormMetaProps,
    DeleteFlagCategoryMetaProps,
    ShiftFormModalMetaProps,
    DuplicateShiftModalMetaProps,
    CopyShiftAllocationsModalMetaProps,
    CompletionQuestionsModalMetaProps,
    TermsAndConditionsMetaProps,
    TrainingFormModalMetaProps,
    TrainingListMetaProps,
    TrainingModulePageMetaProps,
    UnsupportedModuleViewerMetaProps,
    UpdateAreaFormMetaProps,
    UpdateDutyFormMetaProps,
    UpdateEventFormMetaProps,
    UpdatePreferenceFormMetaProps,
    UpdateFlagFormMetaProps,
    UpdateShiftFormMetaProps,
    UpdateTrainingFormMetaProps,
    VideoPlayerMetaProps,
    VolunteerCardMetaProps,
    VolunteerFormModalMetaProps,
    VolunteerProfileMetaProps,
    VolunteersMetaProps,
    VolunteerTrainingPageDetailsMetaProps,
    VolunteerTrainingPageMetaProps,
    VolunteerPoliciesMetaProps,
    TrainingModuleMetaProps,
    AnnouncementMetaProps,
    AnnouncementFormModalMetaProps,
    AnnouncementViewModalMetaProps,
    BulkTrainingAssignmentFormMetaProps,
    ShiftAssignmentFormMetaProps,
    VolunteerFiltersWithConflictProps,
    UserFormModalMetaProps,
    UpdateUserFormMetaProps,
    DeleteUserMetaProps,
    LeadAssignModalPropsMeta,
    AccessColorMetaProps,
    AccessColorFormModalMetaProps,
    CoreTeamMetaProps,
    CoreTeamStatsMetaProps,
    CoreTeamTableMetaProps,
    RejectedCoreTeamTableMetaProps,
    CoreTeamFormModalMetaProps,
    CoreTeamAddModalMetaProps,
    Role,
    TrainingSequenceEditMetaProps,
    MaxChartSize,
    ManagementAnalyticsMetaProps,
    AnalyticsTab,
    VolunteerOverviewMetaProps,
    DashboardMetaProps,
    InternationalRegisterationsMetaProps,
    CoreStreamOverviewMetaProps,
    VolunteerStatsTableOverviewMetaProps,
    DidarAcknowledgementOverviewMetaProps,
    EmailCampaignsMetaProps,
    EmailCampaignFormMetaProps,
    EmailCampaignPreviewMetaProps,
    ShiftMoveModalMetaProps,
    VolunteerUploadDocumentFormMetaProps,
    AllocationStatusPageMetaProps,
    CheckInPageMetaProps,
    DutyStatusOverviewMetaProps,
    QuickAllocateModalMetaProps,
    LiveOperationsMetaProps,
    LiveStatusTab,
    LoginFormMetaProps,
    ForgetPasswordMetaProps,
    ResetPasswordMetaProps,
    SignupMetaProps,
    VerifyEmailMetaProps,
    HouseholdSelectionMetaProps,
    CheckInLoginFormMetaProps,
    PublicFormFillMetaProps,
    PublicFormsMetaProps,
    GuidelineFormModalMetaProps,
    AdminGuidelinesMetaProps,
    VolunteerGuidelinesMetaProps,
    GuidelineDetailsMetaProps,
    DirectorVolunteerMetaProps
} from './types'
import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from '../icons'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'
const IIUK_BASE_URL = process.env.REACT_APP_IIUK_BASE_URL || 'https://iiuk.org'

export const ROLE_MAP: { [key in Role]: string } = {
    volunteer: 'داوطلب',
    lead: 'سرگروه',
    super_lead: 'سرگروه ارشد',
    allocating_lead: 'سرگروه تخصیص',
    reallocation_manager: 'مدیر تخصیص مجدد',
    core_team: 'تیم اصلی',
    core_team_approver: 'تاییدکننده تیم اصلی',
    hr_team_member: 'عضو تیم منابع انسانی',
    hr_deputy: 'معاون منابع انسانی',
    hr_admin: 'مدیر منابع انسانی',
    admin: 'مدیر سیستم',
    checkin_volunteer: 'داوطلب اعلام حضور',
    checkin_admin: 'مدیر اعلام حضور',
    lead_with_stats: 'سرگروه با آمار',
    jv_exec: 'JV Exec',
    jv_lead: 'JV Lead',
    iv_director: 'IV Director',
    iv_deputy_director: 'IV Deputy Director'
}

const HeaderNav: Nav = {
    home: { title: 'خانه', path: `/` },
    profile: { title: 'پروفایل', path: `/profile` },
    trainings: { title: 'آموزش‌های من', path: '/volunteer/training' },
    policies: { title: 'قوانین', path: '/volunteer/policies' },
    events: { title: 'رویدادها', path: '/events', show: (user) => user.permissions?.includes('view_events') && user.permissions.includes('view_admin_hub') },
    check_in: { title: 'اعلام حضور', path: '/admin/check-in', show: (user) => user.permissions?.includes('manage_check_ins') },
    coreTeam: { title: 'تیم اصلی', path: '/core-team', show: (user) => user.permissions?.includes('view_core_team') },
    admin: { title: 'مدیریت', path: `/admin`, show: (user) => user.permissions?.includes('view_admin_hub') },
    faq: { title: 'سوالات متداول', path: 'https://iv.iiuk.org/vms-faq/' },
}

export const HeaderMeta: HeaderMetaProps = {
    title: 'سیستم مدیریت داوطلبان',
    themeToggleLightLabel: 'تغییر به حالت روشن',
    themeToggleDarkLabel: 'تغییر به حالت تاریک',
    themeToggleSystemLabel: 'استفاده از تم سیستم',
    languageSelectorLabel: 'انتخاب زبان',
    logout: 'خروج',
    loggingOutText: 'در حال خروج...',
    nav: HeaderNav
}

export const FooterMeta: FooterMetaProps = {
    nav: {
        termsAndCondition: 'شرایط استفاده',
        privacyNotice: 'حریم خصوصی'
    },
    version: 2026,
    copyRight: 'تمامی حقوق محفوظ است'
}

export const TermsAndConditionsMeta: TermsAndConditionsMetaProps = {
    title: 'رضایت‌نامه داده‌های داوطلب و اطلاعیه حریم خصوصی',
    content: `با ثبت‌نام، شما تأیید می‌کنید و می‌پذیرید که سیستم VMS داوطلبان اسماعیلی، داده‌های شخصی شما را برای مدیریت امور داوطلبانه، از جمله تطبیق شما با وظایف مناسب و مدیریت آموزش‌های شما، جمع‌آوری و استفاده خواهد کرد.

**آنچه ما ذخیره می‌کنیم**: ما تنها اطلاعات مرتبط با داوطلب را نگهداری می‌کنیم که ممکن است شامل نام کامل، آدرس ایمیل، شماره تلفن همراه، گروه سنی، ترجیحات وظیفه و مهارت‌ها باشد. در صورت داشتن بررسی‌های سوابق (Disclosure & Barring Services)، ممکن است این اطلاعات را نیز ثبت کنیم.

**اشتراک‌گذاری اطلاعات تماس شما (برای مقاصد داوطلبانه)**: برای حمایت از فعالیت‌های داوطلبانه، اطلاعات تماس شما ممکن است با رهبر(ان) تیم مربوطه در کمیته ما یا با مخاطبین نهاد مربوطه (در صورت لزوم) به اشتراک گذاشته شود تا بتوانند در مورد وظایف داوطلبانه، زمان‌بندی‌ها، به‌روزرسانی‌ها و الزامات عملیاتی با شما تماس بگیرند.

**سوابق آموزش و وظایف**: شما درک می‌کنید که فعالیت‌های آموزشی شما (مانند تکمیل ویدیوهای یادگیری/آموزشی) و مشارکت/تخصیص وظایف ممکن است برای اهداف عملیاتی، ایمنی و رعایت مقررات در پروفایل داوطلبانه شما ثبت و ذخیره شود.

**حفاظت از داده‌ها**: ما داده‌های شما را مطابق با قوانین و مقررات قابل اجرا پردازش و ذخیره خواهیم کرد و از اقدامات امنیتی فنی و سازمانی مناسب استفاده می‌کنیم. داده‌ها تنها تا زمانی که برای مدیریت امور داوطلبانه و الزامات قانونی/نظارتی لازم باشد، نگهداری خواهند شد.\n\nبا پذیرش این موارد، من تأیید می‌کنم که مطالب فوق را خوانده و با آن‌ها موافقم و رضایت می‌دهم که داده‌های من برای مدیریت داوطلبان به شرح بالا پردازش شود.`,
    agreeButton: 'موافقم',
    disagreeButton: 'مخالفم'
}


export const AdminHubMeta: AdminHubMetaProps = {
    title: 'مرکز مدیریت',
    description: 'دسترسی به تمام ابزارهای مدیریتی و ویژگی‌های سیستم',
    dashboardTitle: 'داشبورد',
    dashboardDescription: 'نمای کلی کاربران و داوطلبان',
    eventsTitle: 'رویدادها',
    eventsDescription: 'ایجاد و مدیریت رویدادها، بخش‌ها و شیفت‌ها',
    volunteersTitle: 'داوطلبان',
    volunteersDescription: 'مدیریت پروفایل داوطلبان و تخصیص‌ها',
    trainingsTitle: 'آموزش‌ها',
    trainingsDescription: 'ایجاد و مدیریت محتوای آموزشی و ماژول‌ها',
    dutiesTitle: 'وظایف',
    dutiesDescription: 'تعریف و مدیریت انواع وظایف برای شیفت‌ها',
    preferencesTitle: 'ترجیحات',
    preferencesDescription: 'مدیریت ترجیحات و در دسترس بودن داوطلبان',
    flagsTitle: 'نشان‌ها',
    flagsDescription: 'مدیریت نشان‌ها و ویژگی‌های داوطلبان',
    settingsTitle: 'تنظیمات سیستم',
    settingsDescription: 'پیکربندی تنظیمات کلی سیستم و انجام اقدامات گروهی',
    announcementsTitle: 'اطلاعیه‌ها',
    announcementsDescription: 'ارسال اطلاعیه برای به‌روز نگه داشتن همه داوطلبان',
    userTitle: 'مدیریت کاربران',
    userDescription: 'مدیریت کاربران و نقش‌ها با کنترل دسترسی',
    accessColorTitle: 'رنگ‌های دسترسی',
    accessColorDescription: 'مدیریت رنگ‌های دسترسی برای کنترل ورود داوطلبان به رویداد.',
    emailCampaignsTitle: 'کمپین‌های ایمیل',
    emailCampaignsDescription: 'ایجاد و ارسال ایمیل‌های گروهی به داوطلبان',
    formsTitle: 'Forms',
    formsDescription: 'Create public forms and review submitted responses',
    miTitle: 'آمار',
    miDescription: 'بینش‌ها و تحلیل‌های خلاصه‌شده',
    internationalRegisterationTitle: 'ثبت‌نام‌های غیر IIUK',
    internationalRegisternationDescription: 'مدیریت ثبت‌نام داوطلبان غیر IIUK.',
    allocationStatusTitle: 'پذیرش وظیفه',
    allocationStatusDescription: 'مشاهده و مدیریت وضعیت پذیرش/رد وظایف داوطلبان',
    checkInTitle: 'اعلام حضور',
    checkInDescription: 'اسکن نشان‌ها برای ثبت حضور داوطلبان در وظایفشان',
    eventDayTitle: 'عملیات زنده رویداد',
    eventDayDescription: 'نظارت بر حضور داوطلبان در زمان واقعی، پوشش شیفت‌ها و معیارهای عملیاتی حیاتی',
    userLogTitle: "گزارش کاربر",
    userLogDescription: "نظارت بر فعالیت کاربر",
    guidelineTitle: "دستورالعمل‌ها",
    guidelineDescription: "ایجاد و مدیریت محتوای دستورالعمل",
    JvTitle: "امتیاز داوطلبان نوجوان",
    JVDescription: "مدیریت امتیازهای کسب‌شده توسط داوطلبان نوجوان",
    directorVolunteerTitle: "داوطلبان جماعت‌خانه شما",
    directorVolunteerDescription: "مشاهده تمام داوطلبان جماعت‌خانه شما."
}

export const PublicFormsMeta: PublicFormsMetaProps = {
    title: 'Forms',
    description: 'Create public forms and review responses submitted through shared links',
    backButton: 'Back to Admin Hub',
    createButton: 'Create Form',
    errorTitle: 'Something went wrong',
    noFormsMessage: 'No forms have been created yet.',
    publicUrlLabel: 'Public URL',
    copyLinkButton: 'Copy Link',
    copiedText: 'Copied',
    editButton: 'Edit',
    deleteButton: 'Delete',
    viewResultsButton: 'View Results',
    hideResultsButton: 'Hide Results',
    submissionsTitle: 'Responses',
    noSubmissionsMessage: 'No responses have been submitted yet.',
    submittedAtLabel: 'Submitted',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    submissionsCountLabel: 'responses',
    titleLabel: 'Title',
    slugLabel: 'Custom URL',
    overrideUrlLabel: 'Override URL',
    overrideUrlHelpText: 'Optional. Leave this off to generate a random public link automatically. Turn it on to choose a friendly ending for the URL.',
    customUrlPlaceholder: 'volunteer-interest',
    descriptionLabel: 'Description',
    activeFormLabel: 'Make form live and allow submissions',
    fieldsLabel: 'Fields',
    addFieldButton: 'Add Field',
    fieldLabelLabel: 'Field Label',
    fieldTypeLabel: 'Field Type',
    requiredLabel: 'Required',
    optionsLabel: 'Options',
    optionPlaceholder: 'Option text',
    addOptionButton: 'Add Option',
    removeButton: 'Remove',
    saveButton: 'Save Form',
    savingButton: 'Saving...',
    createModalTitle: 'Create Form',
    editModalTitle: 'Edit Form',
    textTypeLabel: 'Single Line Text',
    emailTypeLabel: 'Email Address',
    checkboxTypeLabel: 'Checkbox Group',
    radioTypeLabel: 'Radio Group',
    selectTypeLabel: 'Dropdown Select',
    deleteTitle: 'Delete Form',
    deleteMessage: 'This will permanently delete the form and all submitted responses.',
    matchByLabel: 'Match volunteers by',
    matchedVolunteerColumn: 'Matched Volunteer',
    matchingLabel: 'Matching...',
    noMatchLabel: 'No match',
    selectMatchButton: (count: number) => `Select (${count})`,
    changeMatchButton: 'Change',
    matchModalTitle: 'Select Matched Volunteer',
    matchModalDescription: 'More than one volunteer matched this email address. Select the correct one.',
    matchIdColumn: 'ID',
    matchNameColumn: 'Name',
    matchEmailColumn: 'Email',
    matchSelectButton: 'Select',
    matchCloseButton: 'Close',
    approveAndAllocateButton: 'Approve & Assign',
    allocateModalTitle: 'Approve and Assign Volunteer',
    allocateEventLabel: 'Event',
    allocateAreaLabel: 'Area',
    allocateShiftLabel: 'Shift',
    allocateSelectEventPlaceholder: 'Select an event',
    allocateSelectAreaPlaceholder: 'Select an area',
    allocateNoShiftsMessage: 'No shifts found for this area.',
    approveAndAllocateConfirmButton: 'Approve & Assign',
    approveAndAllocatingButton: 'Approving...',
    approveAndAllocateSuccessMessage: 'Volunteer approved and assigned successfully.',
    allocateCloseButton: 'Close',
    exportLabel: 'Allow Exports',
    exportResultButton: 'Export Submissions',
    showQrCodeButton: 'Show QR Code',
    qrCodeModalTitle: 'Form QR Code',
    qrCodeModalDescription: 'Scan this code or share the link below to open the public form.',
    downloadPngButton: 'Download PNG',
    qrCodeCloseButton: 'Close'
}

export const PublicFormFillMeta: PublicFormFillMetaProps = {
    loadingText: 'Loading form...',
    errorTitle: 'Unable to load form',
    notFoundMessage: 'This form is not available.',
    requiredLabel: 'Required',
    submitButton: 'Submit',
    submittingText: 'Submitting...',
    successTitle: 'Response Submitted',
    successMessage: 'Thank you. Your response has been recorded.',
    selectPlaceholder: 'Select an option'
}

export const AdminSettingsMeta: AdminSettingsMetaProps = {
    title: 'تنظیمات سیستم',
    description: 'مدیریت تنظیمات کلی سیستم و انجام اقدامات مدیریتی',
    globalSettingsTitle: 'تنظیمات جهانی',
    globalSettingsDescription: 'نشان‌ها و گزینه‌های پیکربندی در سطح سیستم',
    visitAnnouncedTitle: 'بازدید اعلام شد',
    visitAnnouncedDescription: 'تغییر وضعیت اعلام عمومی بازدید. این بر روی محتوای قابل مشاهده برای کاربران تأثیر می‌گذارد.',
    internationalSignupsEnabledTitle: 'ثبت‌نام بین‌المللی فعال شد',
    internationalSignupsEnabledDescription: 'تغییر وضعیت امکان ثبت‌نام برای بازدیدکنندگان بین‌المللی. این بر روی در دسترس بودن گزینه‌های ورود و ثبت‌نام برای بازدیدکنندگان بین‌المللی تأثیر می‌گذارد.',
    showShiftInfoTitle: 'نمایش اطلاعات شیفت',
    showShiftInfoDescription: 'تغییر وضعیت نمایش اطلاعات تخصیص شیفت/وظیفه در صفحه اصلی برای داوطلبان.',
    localModeTitle: 'حالت محلی',
    localModeDescription: 'فعال کردن جستجوی بارکد محلی در طول اعلام حضور. وقتی فعال باشد، بارکدها به جای API خارجی از پایگاه داده محلی جستجو می‌شوند.',
    trainingManagementTitle: 'مدیریت آموزش',
    trainingManagementDescription: 'عملیات گروهی برای مدیریت آموزش‌های داوطلبان',
    assignMandatoryTitle: 'تخصیص آموزش‌های اجباری',
    assignMandatoryDescription: 'تخصیص خودکار تمامی آموزش‌های اجباری به داوطلبانی که هنوز آن‌ها را نگذرانده‌اند',
    assignButton: 'تخصیص به همه داوطلبان',
    assigningText: 'در حال تخصیص...',
    profileManagementTitle: 'مدیریت پروفایل',
    profileManagementDescription: 'عملیات گروهی برای مدیریت پروفایل‌های داوطلبان',
    clearProfilesTitle: 'درخواست به‌روزرسانی پروفایل',
    clearProfilesDescription: 'پاک کردن تمام مهرهای زمانی ارسال پروفایل برای الزام تمامی داوطلبان به بررسی و ارسال مجدد پروفایل‌هایشان',
    clearProfilesButton: 'درخواست تمام پروفایل‌ها',
    clearingProfilesText: 'در حال پاکسازی...'
}

export const HomeMeta: HomeMetaProps = {
    greeting: (userName: string) => `سلام ${userName}،`,
    motd: 'به پورتال سیستم مدیریت داوطلبان اسماعیلی خوش آمدید. این پلتفرم برای حمایت از داوطلبان ما از طریق ارائه یک فضای مشترک برای دسترسی به منابع آموزشی، پیگیری یادگیری و هماهنگی مسئولیت‌های داوطلبانه به شیوه‌ای سنجیده ایجاد شده است. ما از زمان، توجه و تعهدی که همچنان از طریق خدمت (Khidma) خود ارائه می‌دهید سپاسگزاریم.',
    travelInfo: 'اگر قبلاً برنامه‌ریزی سفر دارید و می‌خواهید داوطلب شوید، لطفاً علاقه‌مندی خود را ثبت کنید. داوطلبی بر اساس ترتیبات شخصی است و تمام الزامات سفر، اقامت، ویزا و موارد مرتبط باید به طور مستقل ترتیب داده شود.',
    visitAnnouncedProfileTitle: 'ثبت‌نام برای داوطلبی (دیدار اروپا (برلین))',
    visitAnnouncedProfileMessage: 'لطفاً علاقه‌مندی خود را برای داوطلبی در دیدار اروپا (برلین) آینده ثبت کنید.',
    visitAnnouncedCompleteButton: 'تکمیل ثبت‌نام',
    profileIncompleteWarningTitle: 'پروفایل خود را تکمیل کنید',
    profileIncompleteWarningMessage: 'لطفاً برای دسترسی به تمامی امکانات، پروفایل خود را تکمیل کنید.',
    completeProfileButton: 'تکمیل پروفایل',
    policyIncompleteWarningTitle: 'اقدام مورد نیاز: بررسی قوانین',
    policyIncompleteWarningMessage: (count: number) => `شما ${count} قانون دارید که نیازمند بررسی و تأیید شما است.`,
    reviewPoliciesButton: 'بررسی قوانین',
    volunteerMessagesTitle: 'پیام‌های داوطلب',
    priorityLabel: 'اولویت',
    viewButton: 'مشاهده',
    previousButton: 'قبلی',
    nextButton: 'بعدی',
    pageLabel: 'صفحه',
    assignedTrainingsTitle: 'آموزش‌های اختصاص‌یافته',
    noIncompleteTrainingsMessage: 'تمام آموزش‌های اختصاص‌یافته تکمیل شده است!',
    incompleteTrainingsMessage: (count: number) => `شما ${count} آموزش ناقص دارید.`,
    viewTrainingsButton: 'مشاهده آموزش‌های من',
    assignedShiftsTitle: 'وظایف اختصاص‌یافته',
    noAssignedShiftsMessage: 'در حال حاضر هیچ وظیفه‌ای به شما اختصاص نیافته است.',
    acceptButton: 'پذیرش',
    declineButton: 'رد کردن',
    pendingLabel: 'در انتظار',
    acceptedLabel: 'پذیرفته شده',
    declinedLabel: 'رد شده',
    loadingShiftsText: 'در حال بارگذاری شیفت‌های شما...',
    shiftTimeLabel: 'زمان شیفت',
    eventLabel: 'رویداد',
    areaLabel: 'بخش',
    shiftLabel: 'شیفت',
    shiftLeadLabel: 'سرگروه',
    declineHelperText: 'انتخاب گزینه رد کردن به ما اطلاع می‌دهد که شما برای این وظیفه در دسترس نیستید. از اینکه به ما در برنامه‌ریزی قبلی کمک می‌کنید سپاسگزاریم.',
    dutiesNotYetAssignedMessage: 'وظایف در زمان مناسب تخصیص داده خواهند شد. لطفاً برای دریافت به‌روزرسانی‌ها مرتباً بررسی کنید.',
    // Accept/Decline modal
    acceptThankYouMessage: 'از اینکه خدمت (سوا) خود را می‌پذیرید سپاسگزاریم.',
    confirmAcceptMessage: 'لطفاً تأیید کنید که مایل به پذیرش این خدمت هستید.',
    tknCheckboxLabel: 'من می‌خواهم این وظیفه را به عنوان بخشی از TKN ارائه دهم. این کادر را تنها در صورتی علامت بزنید که در سال 2008 و/یا 2018 نیت TKN ارائه کرده‌اید.',
    ivTieScarfLabel: 'برای خدمت در زمان دیدار، داشتن کراوات/روسری IV الزامی است. آیا در حال حاضر آن را دارید؟',
    ivTieScarfYes: 'بله',
    ivTieScarfNo: 'خیر',
    confirmButton: 'تأیید',
    goBackButton: 'بازگشت',
    declineModalTitle: 'رد وظیفه',
    declineReasonLabel: 'دلیل رد کردن',
    declineReasonPlaceholder: 'لطفاً یک دلیل انتخاب کنید',
    declineDetailsLabel: 'جزئیات اضافی (اختیاری)',
    declineDetailsPlaceholder: 'لطفاً هرگونه اطلاعات اضافی را ارائه دهید...',
    declineReasons: [
        'زمان‌بندی مناسب نیست (ممکن است شیفت دیگری بسته به در دسترس بودن پیشنهاد شود)',
        'تمایلی به انجام این وظیفه خاص ندارم (ممکن است شیفت دیگری بسته به در دسترس بودن پیشنهاد شود)',
        'در این زمان قادر به تعهد نیستم (در روز مربوطه به VRC مراجعه خواهم کرد)',
        'به دلایل شخصی دیگر مایل به ادامه نیستم'
    ],
    submitDeclineButton: 'ارسال',
    cancelButton: 'لغو',
    startTimeLabel: 'زمان شروع',
    endTimeLabel: 'زمان پایان'
}

export const EventsMeta: EventsMetaProps = {
    title: 'رویدادها',
    description: 'مرور و مدیریت تمامی رویدادهای آینده',
    errorTitle: 'خطا در بارگذاری رویدادها',
    noEventsMessage: 'هیچ رویدادی یافت نشد',
    noFilteredEventsMessage: 'هیچ رویدادی با فیلتر فعلی مطابقت ندارد',
    filterLabel: 'فیلتر سریع',
    filterPlaceholder: 'جستجوی رویدادها بر اساس نام...',
    filterPresetsLabel: 'گزینه های آماده',
    clearFilterButton: 'پاک کردن',
    createButton: 'ایجاد رویداد جدید'
}
export const VolunteersMeta: VolunteersMetaProps = {
    title: 'داوطلبان',
    description: 'مرور و مدیریت تمامی داوطلبان',
    errorTitle: 'خطا در بارگذاری داوطلب',
    noEventsMessage: 'هیچ داوطلبی یافت نشد',
    createButton: 'ایجاد داوطلب جدید'
}
export const DutyMeta: DutyMetaProps = {
    title: 'وظایف موجود',
    description: 'مرور و مدیریت تمامی وظایف موجود',
    errorTitle: 'خطا در بارگذاری وظایف',
    noDutyMessage: 'هیچ وظیفه‌ای یافت نشد',
    dutySearchPlaceHolder: 'جستجوی وظیفه بر اساس عنوان...',
    createButton: 'ایجاد وظیفه جدید'
}

export const LoadingSpinnerMeta: LoadingSpinnerMetaProps = {
    loadingText: 'در حال بارگذاری...'
}

export const LoginMeta: LoginMetaProps = {
    ukResidentLoginButton: 'ورود از طریق IIUK',
    internationalVisitorLoginButton: 'جامعه داوطلبان (ثبت‌نام نشده در IIUK)',
    checkInLoginLink: 'ورود برای ثبت حضور',
    helpText: () => <>{`برای دسترسی به VMS، لطفاً با استفاده از مشخصات ورود IIUK خود وارد شوید.

اگر هنوز در IIUK ثبت‌نام نکرده‌اید یا نمی‌توانید به حساب خود دسترسی پیدا کنید، لطفاً ابتدا از گزینه "فراموشی رمز عبور" برای بازیابی دسترسی به IIUK استفاده کنید. پس از بازیابی دسترسی IIUK، قادر خواهید بود به VMS وارد شوید.

اگر همچنان برای ورود مشکلی دارید یا سؤالی دارید، لطفاً با ما در تماس باشید از طریق`} <a href="mailto:ivc@iiuk.org" className='underline text-primary-600'>ivc@iiuk.org</a>.</>,
    pendingApprovalTitle: 'حساب در انتظار تأیید'
}

export const EventCardMeta: EventCardMetaProps = {
    dateLabel: 'تاریخ',
    timeLabel: 'زمان',
    locationLabel: 'مکان',
    areasLabel: 'بخش‌ها',
    addressLabel: 'آدرس',
    areasSingular: 'بخش',
    areasPlural: 'بخش‌ها',
    viewDetailsButton: 'مشاهده جزئیات',
    visibleLabel: 'قابل مشاهده',
    perAreaLabel: 'هر بخش',
    shiftsVisibleTooltip: 'شیفت‌های تأیید شده در این رویداد برای داوطلبان قابل مشاهده است (قابلیت مشاهده در سطح رویداد فعال است)',
    shiftsPerAreaTooltip: 'قابلیت مشاهده شیفت در سطح بخش کنترل می‌شود - بخش‌های فردی را بررسی کنید'
}
export const VolunteerCardMeta: VolunteerCardMetaProps = {
    dateLabel: 'تاریخ',
    timeLabel: 'زمان',
    locationLabel: 'مکان',
    areasLabel: 'بخش‌ها',
    addressLabel: 'آدرس',
    areasSingular: 'بخش',
    areasPlural: 'بخش‌ها',
    viewDetailsButton: 'مشاهده جزئیات'
}
export const DutyCardMeta: DutyCardMetaProps = {
    'nameLabel': 'نام وظیفه'
}

export const PreferenceMeta: PreferenceMetaProps = {
    title: 'ترجیحات موجود',
    description: 'مرور و مدیریت تمامی ترجیحات داوطلبان',
    errorTitle: 'خطا در بارگذاری ترجیحات',
    noPreferenceMessage: 'هیچ ترجیحی یافت نشد',
    preferenceSearchPlaceHolder: 'جستجوی ترجیح بر اساس نام یا دسته...',
    createButton: 'ایجاد ترجیح جدید'
}

export const PreferenceCardMeta: PreferenceCardMetaProps = {
    nameLabel: 'نام ترجیح',
    categoryLabel: 'دسته',
    descriptionLabel: 'توضیحات'
}

export const EventDetailMeta: EventDetailMetaProps = {
    backToEventsButton: 'بازگشت به رویدادها',
    areasTitle: 'بخش‌ها',
    noAreasMessage: 'هیچ بخشی برای این رویداد یافت نشد',
    shiftsTitle: 'شیفت‌ها',
    noShiftsMessage: 'هیچ شیفتی به این بخش اختصاص داده نشده است',
    loadingText: 'در حال بارگذاری...',
    errorTitle: 'خطا',
    dateLabel: 'تاریخ',
    timeLabel: 'زمان',
    startTimeLabel: 'زمان شروع',
    endTimeLabel: 'زمان پایان',
    capacityLabel: 'ظرفیت',
    volunteersLabel: 'داوطلبان',
    maxVolunteersLabel: 'حداکثر داوطلبان',
    descriptionLabel: 'توضیحات',
    locationLabel: 'مکان',
    addressLabel: 'آدرس',
    showShiftsButton: 'نمایش شیفت‌ها',
    hideShiftsButton: 'مخفی کردن شیفت‌ها',
    leadsTitle: "سرگروه‌های رویداد",
    leadNameTitle: "نام سرگروه",
    deputyLeadNameTitle: "جانشین سرگروه",
    contactTitle: "تماس",
    editEventButton: 'ویرایش رویداد',
    copyShiftAllocationsButton: 'Copy allocations',
    exportShiftRegionStatusButton: 'صدور وضعیت شیفت',
    exportingShiftRegionStatusButton: 'در حال صدور...',
    exportShiftRegionStatusError: 'صدور داده‌های وضعیت شیفت ناموفق بود',
    selectEmailCampaignsTitle: 'انتخاب کمپین‌های ایمیل',
    selectEmailCampaignsDescription: 'انتخاب کنید کدام کمپین‌های ایمیل ارسال‌شده برای ستون‌های ایمیل ارسال شد ب/خ در این خروجی محاسبه شوند.',
    selectEmailCampaignsCancelButton: 'لغو',
    selectEmailCampaignsExportButton: 'صدور کمپین‌های انتخاب‌شده',
    selectEmailCampaignsError: 'لطفاً حداقل یک کمپین ایمیل برای این خروجی انتخاب کنید.',
    emailCampaignLoadError: 'بارگذاری کمپین‌های ایمیل ناموفق بود',
    noEmailCampaignsMessage: 'هیچ کمپین ایمیلی برای انتخاب موجود نیست.',
    emailCampaignOptionDetails: (status, sentCount, createdAt) => `${status.replace('_', ' ')} • ${sentCount} ارسال‌شده • ایجاد شده ${new Date(createdAt).toLocaleDateString()}`,
    createAreaButton: 'ایجاد بخش جدید',
    addShiftButton: 'افزودن شیفت',
    required_volunteer_count_label: 'داوطلبان مورد نیاز',
    allocation_count_label: "داوطلبان تخصیص‌یافته",
    leads_count_label: "موقعیت‌های سرگروه",
    multi_allocation_count_label: "با تخصیص‌های متعدد",
    accepted_allocations_label: 'پذیرفته شده',
    rejected_allocations_label: 'رد شده',
    pending_allocations_label: 'در انتظار',
    visibleLabel: 'قابل مشاهده',
    visibleViaEventLabel: 'قابل مشاهده از طریق رویداد',
    hiddenLabel: 'مخفی',
    shiftsVisibleTooltip: 'شیفت‌های تأیید شده در این بخش برای داوطلبان قابل مشاهده است (قابلیت مشاهده در سطح بخش فعال است)',
    shiftsVisibleViaEventTooltip: 'شیفت‌های تأیید شده در این بخش برای داوطلبان قابل مشاهده است (از طریق قابلیت مشاهده در سطح رویداد)',
    shiftsHiddenTooltip: 'شیفت‌ها در این بخش از دید داوطلبان پنهان هستند (قابلیت مشاهده را در سطح بخش یا رویداد فعال کنید)'
}

export const EventFormModalMeta: EventFormModalMetaProps = {
    title: 'ایجاد رویداد جدید',
    nameLabel: 'نام رویداد',
    namePlaceholder: 'نام رویداد را وارد کنید',
    organizerLabel: 'برگزارکننده',
    organizerPlaceholder: 'نام برگزارکننده را وارد کنید',
    startDateLabel: 'تاریخ شروع',
    endDateLabel: 'تاریخ پایان',
    startTimeLabel: 'زمان شروع',
    endTimeLabel: 'زمان پایان',
    locationLabel: 'مکان',
    locationPlaceholder: 'نام محل برگزاری را وارد کنید',
    addressLabel: 'آدرس',
    addressPlaceholder: 'آدرس کامل را وارد کنید',
    cityLabel: 'شهر',
    cityPlaceholder: 'شهر را وارد کنید',
    countryLabel: 'کشور',
    countryPlaceholder: 'کشور را وارد کنید',
    submitButton: 'ایجاد رویداد',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد رویداد ناموفق بود. لطفاً دوباره تلاش کنید.',
    leadNamePlaceholder: 'نام سرگروه',
    leadPhoneNumberPlaceHolder: 'شماره تلفن سرگروه',
    deputyLeadNamePlaceHolder: 'نام جانشین سرگروه',
    deputyLeadPhoneNumberPlaceHolder: 'شماره تلفن جانشین سرگروه',
    leadNameTitle: 'جزئیات سرگروه',
    leadcontactTitle: 'شماره تلفن سرگروه',
    deputyLeadNameTitle: 'جزئیات جانشین سرگروه',
    deputyLeadcontactTitle: 'شماره تلفن جانشین سرگروه',
    required_volunteer_count_title: 'تعداد داوطلب مورد نیاز',
    require_walkie_talkie_label: 'نیاز به بی‌سیم',
    shiftsVisibleLabel: 'شیفت‌ها برای داوطلبان قابل مشاهده است',
    shiftsVisibleDescription: 'هنگام فعال بودن، شیفت‌های تأیید شده در این رویداد برای پذیرش/رد توسط داوطلبان قابل مشاهده خواهد بود. شیفت‌ها نیز باید برای قابل مشاهده بودن تأیید (قفل) شوند.',
    includeInDuplicateChecksLabel: 'گنجاندن در بررسی‌های تکراری',
    includeInDuplicateChecksDescription: 'هنگام فعال بودن، تخصیص‌ها در این رویداد در بررسی‌های تکراری داوطلبان محاسبه می‌شود. برای رویدادهایی که نباید بر شمارش تکراری تأثیر بگذارند غیرفعال کنید.',
}

export const DuplicateEventModalMeta: DuplicateEventModalMetaProps = {
    title: 'کپی کردن رویداد',
    nameLabel: 'نام رویداد',
    namePlaceholder: 'نام رویداد را وارد کنید',
    startDateLabel: 'تاریخ شروع',
    endDateLabel: 'تاریخ پایان',
    startTimeLabel: 'زمان شروع',
    endTimeLabel: 'زمان پایان',
    submitButton: 'کپی رویداد',
    submittingButton: 'در حال کپی...',
    cancelButton: 'لغو',
    errorMessage: 'کپی رویداد ناموفق بود. لطفاً دوباره تلاش کنید.',
    description: 'این کار یک کپی از رویداد شامل تمام بخش‌ها و شیفت‌ها ایجاد می‌کند، اما شامل تخصیص‌های داوطلبان نمی‌شود. شما می‌توانید نام و تاریخ‌ها را برای رویداد جدید تغییر دهید.'
}

export const VolunteerFormModalMeta: VolunteerFormModalMetaProps = {
    title: 'اطلاعات داوطلب',
    nameLabel: 'نام',
    namePlaceholder: 'نام را وارد کنید',
    lastNameLabel: 'نام خانوادگی',
    lastNamePlaceholder: 'نام خانوادگی را وارد کنید',
    secondLastNameLabel: 'نام خانوادگی دوم',
    secondLastNamePlaceholder: 'نام خانوادگی دوم را وارد کنید (اختیاری)',
    genderLabel: 'جنسیت',
    dobLabel: 'تاریخ تولد',
    contactLabel: 'شماره تلفن',
    contactPlaceholder: 'شماره تلفن را وارد کنید',
    countryCodeLabel: 'کد کشور',
    EmailLabel: 'ایمیل',
    EmailPlaceholder: 'آدرس ایمیل را وارد کنید',
    CountryofResidence: 'کشور محل اقامت',
    countryOfBirthLabel: 'کشور محل تولد',
    Jamatkhana: 'جماعت‌خانه',
    FamilyOriginLabel: 'اصالت خانوادگی',
    serviceLocationLabel: 'محل خدمت',
    serviceRecordLabel: 'لطفاً به ما اطلاع دهید که آیا مایلید به عنوان داوطلب یونیفورم‌دار یا داوطلب بدون یونیفورم خدمت کنید',
    languagesLabel: 'زبان‌ها',
    supportNeedsLabel: 'نیازهای ویژه پشتیبانی',
    supportNeedsPlaceholder: 'لطفاً اگر به کمک خاصی نیاز دارید به ما اطلاع دهید',
    volunteerStatusLabel: 'وضعیت داوطلب',
    ismailiLabel: 'اسماعیلی',
    multiFaithFamilyLabel: 'خانواده چند‌دینی',
    registeredVolunteerLabel: 'داوطلب ثبت‌نام شده',
    eligibleForDutyLabel: 'واجد شرایط برای وظیفه',
    preferencesLabel: 'ترجیحات',
    flagsLabel: 'جزئیات اضافی داوطلب',
    submitButton: 'ارسال',
    submittingButton: 'در حال ارسال...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ارسال پروفایل ناموفق بود. لطفاً دوباره تلاش کنید.',
    volunteerForVisit: 'آیا می‌خواهید در طول دیدار داوطلب شوید؟',
    availabilityLabel: 'لطفاً نحوه تمایل خود برای کمک را مشخص کنید (می‌توانید چند گزینه را انتخاب کنید):',
    negativeListLabel: "عدم توانایی در انجام وظایف",
    registrationNote: () => <>
        لطفاً اطمینان حاصل کنید که برای دیدار اروپا (برلین) (در صورت واجد شرایط بودن) از طریق <Link to={`${IIUK_BASE_URL}`} className='font-medium underline inline-block break-inside-avoid' target='_blank'>IIUK <ExternalLinkIcon className='inline w-3.5 h-3.5' /></Link> یا اپلیکیشن Ismaili ثبت‌نام کرده‌اید.<br />
        این ثبت‌نام <i>فقط</i> برای مدیریت داوطلبان است و به منزله ثبت‌نام برای دیدار اروپا (برلین) <i>نیست</i>.
    </>,
    registrationAckLabel: 'متوجه شدم',
    successMessage: 'پروفایل داوطلبی شما با موفقیت ارسال شد.',
}

export const DutyFormModalMeta: DutyFormModalMetaProps = {
    title: 'ایجاد وظیفه جدید',
    negativeListMemberLabel: 'شامل کردن در لیست منفی',
    nameLabel: 'نام',
    namePlaceholder: 'نام وظیفه را وارد کنید',
    submitButton: 'ایجاد وظیفه',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد وظیفه ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const PreferenceFormModalMeta: PreferenceFormModalMetaProps = {
    title: 'ایجاد ترجیح جدید',
    nameLabel: 'نام',
    namePlaceholder: 'نام ترجیح را وارد کنید',
    categoryLabel: 'دسته',
    categoryPlaceholder: 'دسته را وارد کنید',
    descriptionLabel: 'توضیحات',
    descriptionPlaceholder: 'توضیحات را وارد کنید',
    submitButton: 'ایجاد ترجیح',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد ترجیح ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const DeleteDutyMeta: DeleteDutyMetaProps = {
    deleteButtonText: 'حذف وظیفه',
    confirmTitle: 'حذف وظیفه',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این وظیفه را حذف کنید؟ این اقدام قابل بازگشت نیست و وظیفه انتخاب شده را حذف می‌کند.'
}

export const DeletePreferenceMeta: DeletePreferenceMetaProps = {
    deleteButtonText: 'حذف ترجیح',
    confirmTitle: 'حذف ترجیح',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این ترجیح را حذف کنید؟ این اقدام قابل بازگشت نیست و ترجیح انتخاب شده را حذف می‌کند.'
}

export const FlagMeta: FlagMetaProps = {
    title: 'نشان‌های موجود',
    description: 'مرور و مدیریت تمامی نشان‌های داوطلبان',
    errorTitle: 'خطا در بارگذاری نشان‌ها',
    noFlagMessage: 'هیچ نشانی یافت نشد',
    flagSearchPlaceHolder: 'جستجوی نشان بر اساس نام...',
    createButton: 'ایجاد نشان جدید',
    categorySectionTitle: 'دسته‌های نشان',
    noCategoryMessage: 'هیچ دسته‌ای یافت نشد',
    createCategoryButton: 'ایجاد دسته جدید'
}

export const CoreTeamMeta: CoreTeamMetaProps = {
    title: 'تیم اصلی',
    description: 'مشاهده و مدیریت اعضای تیم اصلی در تمام جریان‌ها',
    createButton: 'افزودن عضو تیم اصلی',
    errorTitle: 'خطا در بارگذاری تیم اصلی',
    noDataMessage: 'هیچ عضو تیم اصلی یافت نشد',
    loadingText: 'در حال بارگذاری اعضای تیم اصلی...'
}

export const CoreTeamStatsMeta: CoreTeamStatsMetaProps = {
    statsTitle: 'آمار',
    showStatsButton: 'نمایش آمار',
    hideStatsButton: 'مخفی کردن آمار',
    genderTitle: 'جنسیت',
    regionTitle: 'منطقه',
    familyOriginTitle: 'اصالت خانوادگی',
    londonLabel: 'لندن',
    notLondonLabel: 'غیر لندن',
    excludedReservedNote: '(رده رزرو شده مستثنی است)',
    otherLabel: 'سایر'
}

export const CoreTeamTableMeta: CoreTeamTableMetaProps = {
    idColumn: 'شناسه',
    nameColumn: 'نام',
    streamsColumn: 'جریان‌ها',
    roleColumn: 'نقش',
    tierColumn: 'رده',
    phoneColumn: 'تلفن',
    emailColumn: 'ایمیل',
    ismailiColumn: 'اسماعیلی',
    familyOriginColumn: 'اصالت خانوادگی',
    ageBandColumn: 'گروه سنی',
    notesColumn: 'یادداشت‌ها',
    duplicationsColumn: 'تکرارها',
    submittedByColumn: 'ارسال شده توسط',
    statusColumn: 'وضعیت تأیید',
    activityStatusColumn: 'وضعیت فعالیت',
    actionsColumn: 'اقدامات',
    approvedStatus: 'تأیید شده',
    pendingStatus: 'ارسال شده',
    activeStatus: 'فعال',
    onHoldStatus: 'در حالت انتظار',
    approveButton: 'تأیید',
    rejectButton: 'رد کردن',
    yesLabel: 'بله',
    noLabel: 'خیر',
    viewAllocationsButton: (count: number) => `مشاهده تکرارها (${count})`,
    streamFilterLabel: 'جریان',
    allStreamsLabel: 'همه جریان‌ها',
    tierFilterLabel: 'رده',
    allTiersLabel: 'همه رده‌ها',
    statusFilterLabel: 'وضعیت تأیید',
    allStatusLabel: 'همه وضعیت‌ها',
    activityStatusFilterLabel: 'وضعیت فعالیت',
    allActivityStatusLabel: 'همه',
    duplicationsFilterLabel: 'تکرارها',
    anyDuplicationsLabel: 'هر کدام',
    hasDuplicationsLabel: 'دارای تکرار',
    noDuplicationsLabel: 'بدون تکرار',
    putOnHoldButton: 'قرار دادن در حالت انتظار',
    makeActiveButton: 'فعال کردن',
    selectedCountLabel: (count: number) => `${count} انتخاب شده`,
    clearSelectionLabel: 'پاک کردن انتخاب',
    bulkApproveLabel: 'تأیید',
    bulkApprovingLabel: 'در حال تأیید...',
    bulkRejectLabel: 'رد کردن',
    bulkRejectingLabel: 'در حال رد کردن...',
    bulkUnapproveLabel: 'لغو تأیید',
    bulkUnapprovingLabel: 'در حال لغو تأیید...',
    bulkDeleteLabel: 'حذف',
    bulkDeletingLabel: 'در حال حذف...',
    bulkPutOnHoldLabel: 'قرار دادن در حالت انتظار',
    bulkPuttingOnHoldLabel: 'در حال قرار دادن در حالت انتظار...',
    bulkMakeActiveLabel: 'فعال کردن',
    bulkMakingActiveLabel: 'در حال فعال کردن...',
    previousPageLabel: 'قبلی',
    nextPageLabel: 'بعدی',
    pageInfoLabel: (start: number, end: number, total: number) => `نمایش ${start}-${end} از ${total}`,
    rowsPerPageLabel: 'ردیف در هر صفحه',
    exportButton: 'خروجی CSV'
}

export const RejectedCoreTeamTableMeta: RejectedCoreTeamTableMetaProps = {
    title: 'ورودی‌های رد شده تیم اصلی',
    nameColumn: 'نام',
    streamsColumn: 'جریان‌ها',
    roleColumn: 'نقش',
    tierColumn: 'رده',
    rejectedByColumn: 'رد شده توسط',
    rejectedDateColumn: 'تاریخ رد',
    deleteButton: 'حذف',
    deletingButton: 'در حال حذف...',
    noDataMessage: 'هیچ ورودی رد شده‌ای یافت نشد',
    searchPlaceholder: 'جستجوی ورودی‌های رد شده...',
    clearFiltersButton: 'پاک کردن',
    exportButton: 'خروجی CSV'
}

export const CoreTeamFormModalMeta: CoreTeamFormModalMetaProps = {
    title: 'افزودن عضو تیم اصلی',
    volunteerLabel: 'داوطلب',
    submittedByLabel: 'ارسال شده توسط',
    streamsLabel: 'جریان‌ها',
    streamsSelectedLabel: 'جریان انتخاب شده',
    streamsRequiredError: 'لطفاً حداقل یک جریان را انتخاب کنید',
    statusLabel: 'وضعیت فعالیت',
    activeStatus: 'فعال',
    onHoldStatus: 'در حالت انتظار',
    roleLabel: 'نقش',
    rolePlaceholder: 'نقش را وارد کنید (مثلا ExCo, PMO)',
    roleRequiredError: 'نقش الزامی است',
    tierLabel: 'رده',
    tierRequiredError: 'رده الزامی است',
    notesLabel: 'یادداشت‌ها (اختیاری)',
    notesPlaceholder: 'هرگونه یادداشت اضافی را وارد کنید',
    submitButton: 'ارسال برای تأیید',
    submittingButton: 'در حال ارسال...',
    cancelButton: 'لغو',
    errorMessage: 'افزودن عضو تیم اصلی ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const CoreTeamAddModalMeta: CoreTeamAddModalMetaProps = {
    title: 'انتخاب داوطلب برای افزودن',
    nameSearchPlaceholder: 'جستجو بر اساس نام...',
    emailSearchPlaceholder: 'جستجو بر اساس ایمیل...',
    phoneSearchPlaceholder: 'جستجو بر اساس تلفن...',
    idSearchPlaceholder: 'جستجو بر اساس شناسه...',
    searchButton: 'جستجو',
    clearButton: 'پاک کردن',
    loadingText: 'در حال بارگذاری داوطلبان...',
    pagesLabel: 'صفحات',
    showingLabel: 'نمایش',
    volunteersLabel: 'داوطلبان',
    noResultsMessage: 'هیچ داوطلبی مطابق با جستجوی شما یافت نشد',
    noVolunteersMessage: 'تمام داوطلبان در حال حاضر در تیم اصلی هستند',
    idColumn: 'شناسه',
    nameColumn: 'نام',
    phoneColumn: 'تلفن',
    emailColumn: 'ایمیل',
    jamatKhanaColumn: 'جماعت‌خانه',
    duplicationsColumn: 'تکرارها',
    viewDuplicationsButton: (count: number) => `مشاهده (${count})`,
    actionColumn: 'اقدام',
    addButton: 'افزودن',
    closeButton: 'بستن',
    errorMessage: 'بارگذاری داوطلبان ناموفق بود. لطفاً دوباره تلاش کنید.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `تکرارها برای ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `تخصیص‌های شیفت (${count})`,
    excludedAllocationsTitle: (count: number) => `مستثنی شده از شمارش تکراری (${count})`,
    excludedAllocationsDescription: 'این تخصیص‌ها از رویدادهایی هستند که در بررسی‌های تکراری لحاظ نمی‌شوند.',
    coreTeamAssignmentsTitle: (count: number) => `تخصیص‌های تیم اصلی (${count})`,
    leadPositionsTitle: (count: number) => `موقعیت‌های سرگروه/جانشین سرگروه (${count})`,
    excludedLeadPositionsTitle: (count: number) => `موقعیت‌های سرگروه مستثنی شده (${count})`,
    excludedLeadPositionsDescription: 'این موقعیت‌های سرگروه از رویدادهایی هستند که در بررسی‌های تکراری لحاظ نمی‌شوند.',
    positionTypeColumn: 'نوع',
    statusColumn: 'وضعیت',
    eventColumn: 'رویداد',
    areaColumn: 'بخش',
    shiftColumn: 'شیفت',
    dateTimeColumn: 'تاریخ/زمان',
    noDuplicationsMessage: 'هیچ تخصیص دیگر یا تخصیص تیم اصلی یافت نشد.',
    closeModalButton: 'بستن',
    submittedStatus: 'ارسال شده',
    approvedStatus: 'تأیید شده',
    pendingStatus: 'در انتظار',
    acceptedStatus: 'پذیرفته شده',
    declinedStatus: 'رد شده',
    roleColumn: 'نقش',
    streamsColumn: 'جریان‌ها'
}

export const FlagCardMeta: FlagCardMetaProps = {
    nameLabel: 'نام نشان',
    descriptionLabel: 'توضیحات',
    hiddenFromRegistrationLabel: 'پنهان از ثبت‌نام'
}

export const FlagFormModalMeta: FlagFormModalMetaProps = {
    title: 'ایجاد نشان جدید',
    nameLabel: 'نام',
    categoryLabel: 'دسته',
    categoryPlaceholder: 'یک دسته انتخاب کنید (اختیاری)',
    noCategoryOption: 'بدون دسته',
    namePlaceholder: 'نام نشان را وارد کنید (مثلا آموزش دیده آتش‌نشانی، کادر پزشکی)',
    descriptionLabel: 'توضیحات',
    descriptionPlaceholder: 'توضیحات نشان را وارد کنید',
    hasExpiryLabel: 'دارای تاریخ انقضا',
    hiddenFromRegistrationLabel: 'مخفی کردن از فرم ثبت‌نام',
    submitButton: 'ایجاد نشان',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد نشان ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const UpdateFlagFormMeta: UpdateFlagFormMetaProps = {
    title: 'به‌روزرسانی نشان',
    submitButton: 'به‌روزرسانی نشان',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const DeleteFlagMeta: DeleteFlagMetaProps = {
    deleteButtonText: 'حذف نشان',
    confirmTitle: 'حذف نشان',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این نشان را حذف کنید؟ این اقدام قابل بازگشت نیست و نشان انتخاب شده را حذف می‌کند.'
}

export const FlagCategoryFormModalMeta: FlagCategoryFormModalMetaProps = {
    title: 'ایجاد دسته جدید',
    nameLabel: 'نام دسته',
    namePlaceholder: 'نام دسته را وارد کنید',
    submitButton: 'ایجاد دسته',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    errorMessage: 'ایجاد دسته ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const UpdateFlagCategoryFormMeta: UpdateFlagCategoryFormMetaProps = {
    title: 'به‌روزرسانی دسته',
    submitButton: 'به‌روزرسانی دسته',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const DeleteFlagCategoryMeta: DeleteFlagCategoryMetaProps = {
    deleteButtonText: 'حذف',
    confirmTitle: 'حذف دسته',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این دسته را حذف کنید؟ نشان‌های موجود در این دسته حذف نخواهند شد، اما هیچ دسته‌ای به آن‌ها اختصاص داده نخواهد شد.'
}

export const ConfirmationModalMeta: ConfirmationModalMetaProps = {
    confirmButton: 'حذف',
    cancelButton: 'لغو',
    deletingButton: 'در حال حذف...'
}

export const DeleteEventMeta: DeleteEventMetaProps = {
    deleteButtonText: 'حذف رویداد',
    confirmTitle: 'حذف رویداد',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این رویداد را حذف کنید؟ این اقدام قابل بازگشت نیست و تمام بخش‌ها، شیفت‌ها و تخصیص‌های مرتبط را حذف می‌کند.',
    detailDeleteButtonText: 'حذف رویداد'
}

export const UpdateEventFormMeta: UpdateEventFormMetaProps = {
    title: 'ویرایش رویداد',
    submitButton: 'به‌روزرسانی رویداد',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const UpdateDutyFormMeta: UpdateDutyFormMetaProps = {
    title: 'ویرایش وظیفه',
    submitButton: 'به‌روزرسانی وظیفه',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const UpdatePreferenceFormMeta: UpdatePreferenceFormMetaProps = {
    title: 'ویرایش ترجیح',
    submitButton: 'به‌روزرسانی ترجیح',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const AreaFormModalMeta: AreaFormModalMetaProps = {
    title: 'ایجاد بخش جدید',
    nameLabel: 'نام بخش',
    namePlaceholder: 'نام بخش را وارد کنید',
    submitButton: 'ایجاد بخش',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد بخش ناموفق بود. لطفاً دوباره تلاش کنید.',
    leadNameTitle: 'نام سرگروه',
    leadcontactTitle: 'شماره تلفن سرگروه',
    deputyLeadNameTitle: 'نام جانشین سرگروه',
    deputyLeadcontactTitle: 'شماره تلفن جانشین سرگروه',
    leadNamePlaceholder: 'نام سرگروه را وارد کنید',
    leadPhoneNumberPlaceHolder: 'شماره تلفن سرگروه را وارد کنید',
    deputyLeadNamePlaceHolder: 'نام جانشین سرگروه را وارد کنید',
    deputyLeadPhoneNumberPlaceHolder: 'شماره تلفن جانشین سرگروه را وارد کنید',
    required_volunteer_count_title: 'تعداد داوطلب مورد نیاز',
    accessColorLabel: 'رنگ دسترسی',
    require_walkie_talkie_label: 'نیاز به بی‌سیم',
    shiftsVisibleLabel: 'شیفت‌ها برای داوطلبان قابل مشاهده است',
    shiftsVisibleDescription: 'هنگام فعال بودن، شیفت‌های تأیید شده در این بخش برای پذیرش/رد توسط داوطلبان قابل مشاهده خواهد بود. شیفت‌ها نیز باید برای قابل مشاهده بودن تأیید (قفل) شوند.',
}

export const UpdateAreaFormMeta: UpdateAreaFormMetaProps = {
    title: 'ویرایش بخش',
    submitButton: 'به‌روزرسانی بخش',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const DeleteAreaMeta: DeleteAreaMetaProps = {
    deleteButtonText: 'حذف بخش',
    confirmTitle: 'حذف بخش',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این بخش را حذف کنید؟ این اقدام قابل بازگشت نیست و تمام شیفت‌ها و تخصیص‌های مرتبط را حذف می‌کند.'
}

export const ShiftFormModalMeta: ShiftFormModalMetaProps = {
    title: 'ایجاد شیفت جدید',
    dutyLabel: 'نوع وظیفه',
    dutyPlaceholder: 'یک نوع وظیفه انتخاب کنید',
    startTimeLabel: 'زمان شروع',
    endTimeLabel: 'زمان پایان',
    submitButton: 'ایجاد شیفت',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد شیفت ناموفق بود. لطفاً دوباره تلاش کنید.',
    leadNameTitle: 'نام سرگروه',
    leadcontactTitle: 'شماره تلفن سرگروه',
    deputyLeadNameTitle: 'نام جانشین سرگروه',
    deputyLeadcontactTitle: 'شماره تلفن جانشین سرگروه',
    leadNamePlaceholder: 'نام سرگروه را وارد کنید',
    leadPhoneNumberPlaceHolder: 'شماره تلفن سرگروه را وارد کنید',
    deputyLeadNamePlaceHolder: 'نام جانشین سرگروه را وارد کنید',
    deputyLeadPhoneNumberPlaceHolder: 'شماره تلفن جانشین سرگروه را وارد کنید',
    required_volunteer_count_lable: 'تعداد داوطلب مورد نیاز',
    accessColorLabel: 'رنگ دسترسی',
    require_walkie_talkie_label: 'نیاز به بی‌سیم',
    criteriaLabel: 'معیارها (اختیاری)',
    criteriaPlaceHolder: 'معیارهای دقیق یا یادداشت‌ها را وارد کنید...',
    titleLabel: 'عنوان',
    titlePlaceHolder: 'عنوان شیفت را وارد کنید...',
    instructionLabel: 'دستورالعمل‌ها (اختیاری)',
    instructionPlaceHolder: 'دستورالعمل‌های خود را اینجا وارد کنید...'
}

export const UpdateShiftFormMeta: UpdateShiftFormMetaProps = {
    title: 'ویرایش شیفت',
    submitButton: 'به‌روزرسانی شیفت',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const DuplicateShiftModalMeta: DuplicateShiftModalMetaProps = {
    title: 'کپی کردن شیفت',
    description: 'ایجاد کپی از این شیفت. می‌توانید انتخاب کنید که تخصیص‌های داوطلبان شامل شود یا خیر، و در همان بخش یا در رویداد/بخش متفاوتی کپی شود.',
    countLabel: 'تعداد کپی‌ها',
    countPlaceholder: 'تعداد را وارد کنید (1-50)',
    countValidationError: 'تعداد باید بین 1 و 50 باشد',
    includeAllocationsLabel: 'شامل تخصیص‌های داوطلب',
    includeAllocationsDescription: 'در صورت علامت زدن، تمام تخصیص‌های داوطلب فعلی در شیفت(های) جدید کپی می‌شود.',
    destinationLabel: 'مقصد',
    sameAreaLabel: 'همان بخش',
    differentAreaLabel: 'رویداد/بخش متفاوت',
    eventLabel: 'رویداد',
    selectEventPlaceholder: 'یک رویداد انتخاب کنید',
    areaLabel: 'بخش',
    selectAreaPlaceholder: 'یک بخش انتخاب کنید',
    selectAreaError: 'لطفاً یک بخش را برای شیفت(های) کپی شده انتخاب کنید',
    submitButton: 'کپی کردن',
    submittingButton: 'در حال کپی...',
    cancelButton: 'لغو',
    errorMessage: 'کپی شیفت ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const CopyShiftAllocationsModalMeta: CopyShiftAllocationsModalMetaProps = {
    title: 'Copy Shift Allocations',
    description: 'Copy the volunteers allocated to this shift into another shift. The destination shift times will be used and copied allocations will start as pending.',
    sourceShiftLabel: 'Source shift',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    areaLabel: 'Area',
    selectAreaPlaceholder: 'Select an area',
    shiftLabel: 'Shift',
    selectShiftPlaceholder: 'Select a shift',
    selectShiftError: 'Please select a destination shift',
    noTargetShiftsMessage: 'No other shifts available in this area',
    loadEventsError: 'Failed to load events',
    submitButton: 'Copy Allocations',
    submittingButton: 'Copying...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to copy shift allocations. Please try again.'
}

export const DuplicateAreaModalMeta: DuplicateAreaModalMetaProps = {
    title: 'کپی کردن بخش',
    description: 'ایجاد کپی از این بخش و تمام شیفت‌های آن. می‌توانید انتخاب کنید که تخصیص‌های داوطلبان شامل شود یا خیر، و در همان رویداد یا رویداد متفاوتی کپی شود.',
    countLabel: 'تعداد کپی‌ها',
    countPlaceholder: 'تعداد را وارد کنید (1-50)',
    countValidationError: 'تعداد باید بین 1 و 50 باشد',
    includeAllocationsLabel: 'شامل تخصیص‌های داوطلب',
    includeAllocationsDescription: 'در صورت علامت زدن، تمام تخصیص‌های فعلی شیفت‌ها در این بخش به بخش(های) جدید کپی می‌شود.',
    destinationLabel: 'مقصد',
    sameEventLabel: 'همان رویداد',
    differentEventLabel: 'رویداد متفاوت',
    eventLabel: 'رویداد',
    selectEventPlaceholder: 'یک رویداد انتخاب کنید',
    selectEventError: 'لطفاً یک رویداد را برای بخش(های) کپی شده انتخاب کنید',
    loadEventsError: 'بارگذاری رویدادها ناموفق بود',
    submitButton: 'کپی کردن',
    submittingButton: 'در حال کپی...',
    cancelButton: 'لغو',
    errorMessage: 'کپی بخش ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const DeleteShiftMeta: DeleteShiftMetaProps = {
    confirmTitle: 'حذف شیفت',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این شیفت را حذف کنید؟ این اقدام قابل بازگشت نیست و تمام تخصیص‌های مرتبط را حذف می‌کند.'
}

export const TrainingListMeta: TrainingListMetaProps = {
    assignedTitle: 'آموزش‌های اختصاص‌یافته به من',
    availableTitle: 'سایر آموزش‌های موجود',
    errorTitle: 'خطا در بارگذاری آموزش',
    noAssignedTrainingsMessage: 'در حال حاضر هیچ آموزشی به شما اختصاص نیافته است.',
    noAvailableTrainingsMessage: 'هیچ آموزش دیگری در دسترس نیست.',
    loadingText: 'در حال بارگذاری آموزش...',
    modulesLabel: 'ماژول‌ها',
    durationLabel: 'مدت زمان',
    minutesSuffix: 'دقیقه',
    mandatoryBadge: 'اجباری'
}

export const AdminTrainingsMeta: AdminTrainingsMetaProps = {
    title: 'مدیریت آموزش‌ها',
    description: 'ایجاد، ویرایش و مدیریت ماژول‌های آموزشی برای داوطلبان',
    errorTitle: 'خطا در بارگذاری آموزش‌ها',
    noTrainingsMessage: 'هیچ آموزشی در دسترس نیست. برای افزودن، روی "ایجاد آموزش جدید" کلیک کنید.',
    loadingText: 'در حال بارگذاری آموزش‌ها...',
    assignVolunteersMessage: 'تخصیص به داوطلبان'
}

export const TrainingFormModalMeta: TrainingFormModalMetaProps = {
    title: 'ایجاد آموزش جدید',
    nameLabel: 'نام آموزش',
    namePlaceholder: 'نام آموزش را وارد کنید',
    descriptionLabel: 'توضیحات',
    descriptionPlaceholder: 'توضیحات آموزش را وارد کنید',
    mandatoryLabel: 'آموزش اجباری',
    policyLabel: 'قانون (فقط در صورت ناقص بودن در صفحه اصلی نشان داده می‌شود)',
    modulesLabel: 'ماژول‌های آموزشی',
    addModuleButton: 'افزودن ماژول',
    removeModuleButton: 'حذف',
    moduleTypeLabel: 'نوع ماژول',
    moduleTitleLabel: 'عنوان ماژول',
    moduleTitlePlaceholder: 'عنوان ماژول را وارد کنید',
    moduleUrlLabel: 'لینک (URL)',
    moduleUrlPlaceholder: 'https://example.com/resource',
    moduleFileLabel: 'فایل',
    moduleFilePlaceholder: 'هیچ فایلی انتخاب نشده است',
    moduleFileUploadButton: 'آپلود فایل',
    moduleFileUploadingButton: 'در حال آپلود...',
    moduleFileRemoveButton: 'حذف فایل',
    moduleContentTypeLabel: 'نوع محتوا',
    moduleContentTypeUrl: 'لینک (URL)',
    moduleContentTypeFile: 'آپلود فایل',
    moduleContentTypeLibrary: 'کتابخانه',
    browseLibraryButton: 'مرور کتابخانه',
    libraryBrowserTitle: 'انتخاب ویدیو از کتابخانه',
    libraryBrowserSelectButton: 'انتخاب ویدیو',
    libraryBrowserCancelButton: 'لغو',
    libraryBrowserLoadingText: 'در حال بارگذاری ویدیوها...',
    libraryBrowserErrorText: 'بارگذاری ویدیوها ناموفق بود. لطفاً دوباره تلاش کنید.',
    libraryBrowserNoVideosText: 'هنوز ویدیویی در کتابخانه وجود ندارد.',
    moduleDescriptionLabel: 'توضیحات (اختیاری)',
    moduleDescriptionPlaceholder: 'توضیحات ماژول را وارد کنید',
    moduleDurationLabel: 'مدت زمان (دقیقه)',
    moduleDurationPlaceholder: '15',
    moduleOrderPlaceholder: '0',
    moduleRequiredLabel: 'مورد نیاز',
    noModulesMessage: 'هنوز هیچ ماژولی اضافه نشده است. برای ایجاد اولین ماژول روی "افزودن ماژول" کلیک کنید.',
    submitButton: 'ایجاد آموزش',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد آموزش ناموفق بود. لطفاً دوباره تلاش کنید.',
    questionsLabel: 'سؤالات آموزشی',
    addQuestionButton: 'افزودن سؤال',
    noQuestionMessage: 'هنوز هیچ سؤالی اضافه نشده است. برای ایجاد اولین سؤال روی "افزودن سؤال" کلیک کنید.',
    questionLable: 'سؤال',
    questionPlaceHolder: 'سؤال را اینجا وارد کنید',
    answerDescriptionLabel: 'توضیحات پاسخ (اختیاری)',
    answerDescriptionPlaceholder: 'زمینه یا توضیح اضافی برای این سؤال ارائه دهید',
    optionLabel: 'گزینه',
    addOptionButton: 'افزودن گزینه',
    noOptionMessage: 'هنوز هیچ گزینه‌ای اضافه نشده است. برای ایجاد اولین گزینه روی "افزودن گزینه" کلیک کنید.',
    optionPlaceHolder: 'گزینه را اینجا وارد کنید',
    optionsLabel: 'گزینه‌ها',
    optionSelectionMessage: 'لطفاً گزینه‌ای را انتخاب کنید که پاسخ صحیح است.',
    noOptionsDisplayMessage: 'هیچ گزینه‌ای برای این سؤال در دسترس نیست.'
}

export const UpdateTrainingFormMeta: UpdateTrainingFormMetaProps = {
    title: 'ویرایش آموزش',
    submitButton: 'به‌روزرسانی آموزش',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const DocumentViewerMeta: DocumentViewerMetaProps = {
    loadingText: 'در حال بارگذاری سند...',
    errorTitle: 'خطا در بارگذاری سند',
    errorInvalidUrl: 'لینک (URL) سند ارائه‌شده نامعتبر است.',
    errorLoadingDocument: 'بارگذاری سند ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const VideoPlayerMeta: VideoPlayerMetaProps = {
    loadingText: 'در حال بارگذاری ویدیو...',
    errorTitle: 'خطا در بارگذاری ویدیو',
    errorInvalidUrl: 'لینک (URL) ویدیو ارائه‌شده نامعتبر است.',
    errorLoadingVideo: 'بارگذاری ویدیو ناموفق بود. لطفاً دوباره تلاش کنید.',
    muteLabel: 'بی‌صدا',
    unmuteLabel: 'باصدا',
    enterFullscreenLabel: 'تمام صفحه',
    exitFullscreenLabel: 'خروج از تمام صفحه',
    playbackSpeedLabel: 'سرعت',
    captionsLabel: 'زیرنویس‌ها'
}

export const UnsupportedModuleViewerMeta: UnsupportedModuleViewerMetaProps = {
    title: 'نوع ماژول پشتیبانی نمی‌شود',
    message: 'مشاهده ماژول‌های {type} در حال حاضر پشتیبانی نمی‌شود.',
    supportedTypes: 'در حال حاضر پشتیبانی می‌شود: سند (PDF)، ویدیو (YouTube، Vimeo و غیره)'
}

export const TrainingModulePageMeta: TrainingModulePageMetaProps = {
    backButtonLabel: 'بازگشت به جزئیات آموزش',
    moduleLabel: 'ماژول {current} از {total}',
    previousModuleButton: 'ماژول قبلی',
    nextModuleButton: 'ماژول بعدی',
    errorTitle: 'خطا در بارگذاری ماژول',
    errorInvalidParameters: 'پارامترهای آموزش یا ماژول نامعتبر است.',
    errorTrainingNotFound: 'آموزش یافت نشد.',
    errorModuleNotFound: 'ماژول در این آموزش یافت نشد.',
    errorInvalidContent: 'فرمت محتوای آموزشی نامعتبر است.',
    errorFileNotFound: 'فایل سند یافت نشد.',
    errorNoDocumentSource: 'هیچ لینک (URL) سند یا فایلی برای این ماژول مشخص نشده است.',
    errorNoVideoSource: 'هیچ لینک (URL) ویدیو یا فایلی برای این ماژول مشخص نشده است.',
    errorGeneric: 'هنگام بارگذاری ماژول خطایی رخ داد.',
    documentViewer: DocumentViewerMeta,
    videoViewer: VideoPlayerMeta,
    unsupportedViewer: UnsupportedModuleViewerMeta
}

export const TrainingModuleMeta: TrainingModuleMetaProps = {
    minutesSuffix: 'دقیقه'
}

export const VolunteerTrainingPageMeta: VolunteerTrainingPageMetaProps = {
    title: "آموزش‌های اختصاص‌یافته به شما",
    description: "دسترسی و تکمیل ماژول‌های آموزشی اختصاص‌یافته",
    errorTitle: "خطا",
    noTrainingMessage: "هنوز هیچ آموزشی به شما اختصاص نیافته است.",
    viewButton: "مشاهده آموزش",
}

export const VolunteerPoliciesMeta: VolunteerPoliciesMetaProps = {
    title: "قوانین",
    description: "بررسی و تأیید قوانین مورد نیاز",
    errorTitle: "خطا",
    noPoliciesMessage: "هنوز هیچ قانونی به شما اختصاص نیافته است.",
    outstandingTitle: "قوانین باقی‌مانده",
    acknowledgedTitle: "قوانین تأیید شده",
    viewButton: "مشاهده قانون",
}

export const VolunteerTrainingPageDetailsMeta: VolunteerTrainingPageDetailsMetaProps = {
    backToTrainingsButton: 'بازگشت به آموزش‌ها',
    loadingText: 'در حال بارگذاری آموزش',
    errorTitle: 'خطا در حین بارگذاری جزئیات آموزش.',
    modulesLabel: 'ماژول‌ها',
    totalDurationLabel: 'مجموع مدت زمان',
    minutesSuffix: 'دقیقه',
    mandatoryBadge: 'اجباری',
    completedBadge: 'تکمیل شده',
    inProgressBadge: 'در حال انجام',
    moduleNumberPrefix: 'ماژول',
    completeTrainingButton: 'علامت‌گذاری به عنوان تکمیل شده',
    trainingCompletedMessage: 'این آموزش با موفقیت تکمیل شده است.',
}

export const ModuleCompletionModalMeta: CompletionQuestionsModalMetaProps = {
    title: "سؤالات ماژول",
    submitButton: "ارسال پاسخ‌ها",
    submittingButton: "تکمیل ماژول",
    cancelButton: "لغو"
}

export const ProfileMeta: VolunteerProfileMetaProps = {
    loadingText: 'در حال بارگذاری...',
    errorTitle: 'خطا',
    backToVolunteersButton: 'بازگشت به داوطلبان',
    editProfileButton: 'ویرایش پروفایل',
    completeProfileButton: 'تکمیل پروفایل',
    noAreasMessage: '',
    csid: 'شناسه داوطلب',
    first_name: 'نام',
    last_name: 'نام خانوادگی',
    second_last_name: 'نام خانوادگی دوم',
    gender: 'جنسیت',
    dob: 'تاریخ تولد',
    age: 'سن',
    email: 'ایمیل',
    phone: 'تلفن',
    country_code: 'کد کشور',
    country: 'کشور',
    country_of_birth: 'کشور محل تولد',
    jamat_khana: 'جماعت‌خانه',
    service_location: 'محل خدمت',
    service_record: 'موقعیت IV',
    family_origin: 'اصالت خانوادگی',
    languages: 'زبان‌ها',
    support_needs: 'نیازهای ویژه پشتیبانی',
    multi_faith_family: 'خانواده چند‌دینی',
    ismaili: 'اسماعیلی',
    registered_volunteer_label: 'داوطلب ثبت‌نام شده',
    eligible_for_duty_label: 'واجد شرایط برای وظیفه',
    yes: 'بله',
    no: 'خیر',
    personalInfoSection: 'اطلاعات شخصی',
    locationSection: 'اطلاعات مکانی',
    additionalInfoSection: 'اطلاعات داوطلب',
    preferencesSection: 'ترجیحات',
    flagsSection: 'اطلاعات اضافی',
    trainingsSection: 'آموزش‌های اختصاص‌یافته',
    deleteTrainingMessage: 'آیا مطمئن هستید؟ این آموزش از داوطلب برداشته می‌شود و تمام پیشرفت‌های مرتبط با آن از دست خواهد رفت.',
    deleteTrainingTitle: 'حذف تخصیص آموزش',
    languageSection: 'زبان‌ها',
    volunteer_for_visit_label: 'تمایل به داوطلب شدن برای دیدار دارد؟',
    availability_label: 'در دسترس بودن',
    uploadedDocumentsLabel: "اسناد آپلود شده",
    allocatedShiftsLabel: "تخصیص‌ها",
    eventLeadLabel: "سرگروه رویداد",
    areaLeadLabel: "سرگروه بخش",
    shiftLeadLabel: "سرگروه شیفت",
    otherAllocationLabel: "سایر",
    negativeListLabel: "عدم توانایی در انجام وظایف"
}

export const VolunteerTableMeta = {
    columns: [
        { key: "csid", header: "شناسه (VID)" },
        { key: "first_name", header: "نام" },
        { key: "last_name", header: "نام خانوادگی" },
        { key: "email", header: "ایمیل" },
        { key: "phone", header: "شماره تلفن" },
        { key: "gender", header: "جنسیت" },
        //{ key: "dob", header: "DOB" },
        { key: "age", header: "سن" },
        { key: "country_of_birth", header: "کشور محل تولد" },
        { key: "family_origin", header: "اصالت خانوادگی" },
        { key: "jamat_khana", header: "جماعت‌خانه" },
        { key: "service_record", header: "موقعیت IV" },
        { key: "ismaili", header: "اسماعیلی" },
        { key: "multi_faith_family", header: "خانواده چند‌دینی" },
        { key: "eligible_for_duty", header: "واجد شرایط برای وظیفه" },
        { key: "languages", header: "زبان‌ها" },
        { key: "preferences", header: "ترجیحات" },
        { key: "flags", header: "مهارت‌های اضافی" },
        //{ key: "support_needs", header: "Special Support" },
    ],
};


export const VolunteerTrainingTableMeta = {
    columns: [
        { key: "csid", header: "شناسه (VID)" },
        { key: "first_name", header: "نام" },
        { key: "last_name", header: "نام خانوادگی" },
        { key: "gender", header: "جنسیت" },
        //{ key: "dob", header: "DOB" },
        // { key: "age", header: "Age" },
        { key: "service_record", header: "موقعیت IV" },
        { key: "preferences", header: "ترجیحات" },
        { key: "flags", header: "مهارت‌های اضافی" },
    ],
};

export const VolunteerAllocationTableMeta = {
    columns: [
        { key: "first_name", header: "نام" },
        { key: "last_name", header: "نام خانوادگی" },
        // { key: "gender", header: "Gender" },
        { key: "jamat_khana", header: "جماعت‌خانه" },
        { key: "family_origin", header: "اصالت خانوادگی" },
        { key: "service_record", header: "موقعیت IV" },
        { key: "flags", header: "مهارت‌های اضافی" },
    ],
};

export const ConflictInformationTableMeta = {
    columns: [
        { key: "event_name", header: "رویداد" },
        { key: "area_name", header: "بخش" },
        { key: "shift_title", header: "شیفت" },
        { key: "shift_duty_name", header: "وظیفه" },
        { key: "start_time", header: "شروع شیفت" },
        { key: "end_time", header: "پایان شیفت" },
        { key: "type", header: "دلیل" },
        { key: "action", header: "اقدامات" },
    ],
};

export const VolunteerAllocationViewTableMeta = {
    columns: [
        { key: "first_name", header: "نام" },
        { key: "last_name", header: "نام خانوادگی" },
        { key: "phone", header: "شماره تلفن" },
        { key: "age_band", header: "گروه سنی" },
        { key: "jamat_khana", header: "جماعت‌خانه" },
        { key: "family_origin", header: "اصالت خانوادگی" },
        { key: "service_record", header: "موقعیت IV" },
        { key: "flags", header: "مهارت‌های اضافی" },
        { key: "support_needs", header: "نیازهای پشتیبانی" },
        { key: "action", header: "اقدامات" },
    ],
};

export const VolunteerEventShiftViewTableMeta = {
    columns: [
        { key: "event_name", header: "رویداد" },
        { key: "area_name", header: "بخش" },
        { key: "shift_duty_name", header: "شیفت" },
        { key: "start_time", header: "شروع شیفت" },
        { key: "end_time", header: "پایان شیفت" },
        { key: "status", header: "وضعیت" },
        { key: "action", header: "اقدام" }
    ],
};

export const VolunteerAreaShiftViewTableMeta = {
    columns: [
        { key: "shift_duty_name", header: "شیفت" },
        { key: "start_time", header: "شروع شیفت" },
        { key: "end_time", header: "پایان شیفت" },
        { key: "status", header: "وضعیت" },
        { key: "action", header: "اقدام" }
    ],
};


export const LeadAssginmentViewTableMeta = {
    columns: [
        { key: "first_name", header: "نام" },
        { key: "last_name", header: "نام خانوادگی" },
        { key: "email", header: "ایمیل" },
        { key: "phone", header: "شماره تلفن" },
        { key: "flags", header: "مهارت‌های اضافی" },
    ],
};

export const MIVolunteerViewMeta = {
    columns: [
        { key: "first_name", header: "نام" },
        { key: "last_name", header: "نام خانوادگی" },
        { key: "email", header: "ایمیل" },
        { key: "phone", header: "شماره تلفن" },
        { key: "jamat_khana", header: "جماعت‌خانه" },
        { key: "family_origin", header: "اصالت خانوادگی" },
        { key: "service_record", header: "موقعیت IV" },
        { key: "uk_didar_registration_ack", header: "تأییدیه دیدار" }

    ],
};



export const AssignTrainingFormModalMeta: AssignTrainingFormModalMetaProps = {
    title: "تخصیص آموزش به داوطلب",
    submitButton: "تخصیص",
    submittingButton: "در حال تخصیص",
    cancelButton: "لغو",
    trainingLabel: "آموزش‌های موجود",
    trainingPlaceHolder: "آموزش را انتخاب کنید",
    addTrainingButton: "افزودن آموزش",
    noTrainingMessage: 'هیچ آموزشی هنوز اضافه نشده است. برای افزودن اولین آموزش روی "افزودن آموزش" کلیک کنید.',
    noTrainingSelectedMessage: 'برای تخصیص، حداقل یک آموزش اضافه کنید.'
}

export const AnnouncementMeta: AnnouncementMetaProps = {
    title: 'اطلاعیه‌ها',
    description: 'مدیریت تمامی اطلاعیه‌های ارسال شده به داوطلبان.',
    createButton: 'پست جدید',
    submitButton: 'ارسال',
    submittingButton: 'در حال ارسال...',
    errorTitle: 'دریافت اطلاعیه‌ها ناموفق بود',
    noAnnouncementsMessage: 'هنوز هیچ اطلاعیه‌ای ارسال نشده است.',
    announcementSearchPlaceHolder: 'جستجوی اطلاعیه بر اساس عنوان...',
    backButton: 'بازگشت به مرکز مدیریت',
    onDeleteTitle: 'حذف اطلاعیه',
    onDeleteMessage: 'حذف این اطلاعیه آن را برای تمام کاربران به‌طور دائمی پاک می‌کند. این اقدام قابل بازگشت نیست.'
}

export const AnnouncementsFormModalMeta: AnnouncementFormModalMetaProps = {
    errorMessage: 'خطا در هنگام ارسال فرم رخ داد',
    createTitle: 'ارسال اطلاعیه جدید',
    editTitle: 'جزئیات اطلاعیه',
    cancelButton: 'لغو',
    submitButton: 'ارسال',
    submittingButton: 'در حال ارسال...',
    titleLabel: 'عنوان',
    titlePlaceHolder: 'عنوان اطلاعیه را وارد کنید...',
    contentLabel: 'محتوا',
    contentPlaceHolder: 'محتوای اطلاعیه را وارد کنید...',
    prioritiyMessage: 'علامت‌گذاری به عنوان اولویت'
}

export const AnnouncementViewModalMeta: AnnouncementViewModalMetaProps = {
    viewTitle: 'اطلاعیه',
    titleLabel: 'عنوان',
    contentLabel: 'محتوا',
    prioritiyMessage: 'این یک اطلاعیه با اولویت است.',
    cancelButton: 'بستن'
}

export const BulkTrainingAssignmentFormMeta: BulkTrainingAssignmentFormMetaProps = {
    title: 'تخصیص ',
    cancelButton: 'لغو',
    submitButton: 'تخصیص آموزش',
    submittingButton: 'در حال تخصیص...',
    previewButton: 'پیش‌نمایش',
    previewingButton: 'در حال بارگذاری...',
    // Assignment mode selection
    assignmentModeLabel: 'روش تخصیص',
    modeAllVolunteers: 'همه داوطلبان ثبت‌نام شده',
    modeAllVolunteersDescription: 'تخصیص به تمامی داوطلبان تأیید شده در سیستم',
    modeByEvent: 'بر اساس رویداد',
    modeByEventDescription: 'تخصیص به داوطلبان اختصاص‌یافته به رویدادهای خاص',
    modeByArea: 'بر اساس بخش',
    modeByAreaDescription: 'تخصیص به داوطلبان اختصاص‌یافته به بخش‌های خاص',
    modeByShift: 'بر اساس شیفت',
    modeByShiftDescription: 'تخصیص به داوطلبان اختصاص‌یافته به شیفت‌های خاص',
    modeByDuty: 'بر اساس نوع وظیفه',
    modeByDutyDescription: 'تخصیص به داوطلبان اختصاص‌یافته به شیفت‌هایی با انواع وظایف خاص',
    modeManual: 'انتخاب دستی',
    modeManualDescription: 'فیلتر کردن و انتخاب داوطلبان فردی به‌طور دستی',
    // Selection labels
    selectEventsLabel: 'انتخاب رویدادها',
    selectAreasLabel: 'انتخاب بخش‌ها',
    selectShiftsLabel: 'انتخاب شیفت‌ها',
    selectDutiesLabel: 'انتخاب انواع وظایف',
    // Lead inclusion options
    includeLeadsLabel: 'شامل سرگروه‌ها',
    includeEventLeadsLabel: 'شامل سرگروه‌های رویداد',
    includeAreaLeadsLabel: 'شامل سرگروه‌های بخش',
    includeShiftLeadsLabel: 'شامل سرگروه‌های شیفت',
    // Preview results
    previewResultsTitle: 'پیش‌نمایش',
    totalVolunteersLabel: 'مجموع داوطلبانی که با معیارها مطابقت دارند',
    alreadyAssignedLabel: 'از قبل این آموزش را دارند',
    willBeAssignedLabel: 'اختصاص داده خواهد شد',
    // Messages
    noSelectionMessage: 'لطفاً حداقل یک مورد را انتخاب کنید',
    selectEventFirst: 'برای دیدن بخش‌ها، ابتدا یک رویداد انتخاب کنید',
    selectAreaFirst: 'برای دیدن شیفت‌ها، ابتدا یک بخش انتخاب کنید'
}

export const ShiftAssignmentFormMeta: ShiftAssignmentFormMetaProps = {
    title: 'تخصیص داوطلبان',
    cancelButton: 'لغو',
    submitAllocateButton: 'تخصیص',
    submittingAllocateButton: 'در حال تخصیص...',
    submitRemoveButton: 'حذف',
    submittingRemoveButton: 'در حال حذف...',
    conflictTitle: 'شیفت‌های متداخل',
    conflictMessage: 'شیفت‌های زیر با این تخصیص تداخل دارند.',
    futureConflictMessage: 'شیفت‌های زیر با این تخصیص تداخل خواهند داشت.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `تکرارها برای ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `تخصیص‌های شیفت (${count})`,
    excludedAllocationsTitle: (count: number) => `مستثنی شده از شمارش تکراری (${count})`,
    excludedAllocationsDescription: 'این تخصیص‌ها از رویدادهایی هستند که در بررسی‌های تکراری لحاظ نمی‌شوند.',
    coreTeamAssignmentsTitle: (count: number) => `تخصیص‌های تیم اصلی (${count})`,
    leadPositionsTitle: (count: number) => `موقعیت‌های سرگروه/جانشین سرگروه (${count})`,
    excludedLeadPositionsTitle: (count: number) => `موقعیت‌های سرگروه مستثنی شده (${count})`,
    excludedLeadPositionsDescription: 'این موقعیت‌های سرگروه از رویدادهایی هستند که در بررسی‌های تکراری لحاظ نمی‌شوند.',
    positionTypeColumn: 'نوع',
    statusColumn: 'وضعیت',
    eventColumn: 'رویداد',
    areaColumn: 'بخش',
    shiftColumn: 'شیفت',
    actionsColumn: 'اقدامات',
    dateTimeColumn: 'تاریخ/زمان',
    noDuplicationsMessage: 'هیچ تخصیص دیگر یا تخصیص تیم اصلی یافت نشد.',
    closeModalButton: 'بستن',
    submittedStatus: 'ارسال شده',
    approvedStatus: 'تأیید شده',
    pendingStatus: 'در انتظار',
    acceptedStatus: 'پذیرفته شده',
    declinedStatus: 'رد شده',
    roleColumn: 'نقش',
    streamsColumn: 'جریان‌ها',
    publishShiftTitle: 'ارسال شیفت برای تأیید؟',
    publishShiftMessage: 'پس از ارسال این شیفت، هیچ تخصیص دیگری نمی‌تواند انجام شود یا حذف شود.',
    publishButton: 'ارسال برای تأیید',
    lockButton: 'قفل کردن',
    unlockButton: 'باز کردن قفل'
}

export const AllLanguages = [
    "Arabic",
    "Persian / Farsi",
    "Bengali",
    "English",
    "Gujarati / Kutchi",
    "Urdu / Hindi",
    "Punjabi / Sindhi",
    "French",
    "German",
    "Mandarin Chinese / Japanese",
    "Portuguese",
    "Russian",
    "Spanish",
    "Swahili",
    "Turkish",
    "Tajik",

    "Danish",
    "Swedish",
    "Norwegian",
    "Finish",
    "Dutch",
    "Polish",
    "Italian",
]

export const IVPositions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer"
]

export const IVPositionFilterOptions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer",
    "Volunteer",
    "Junior Volunteer",
    "Team Leader",
    "JV Team Leader",
    "Deputy JV Team Leader",
    "Director",
    "Deputy Director",
    "IV Executive",
    "IV Events",
    "Other"
]

export const GenderOptions = [
    "Male",
    "Female",
    "Prefer Not to Say"
]

export const UserMetaProps = {
    title: 'مدیریت کاربران',
    description: 'مدیریت کاربران و نقش‌ها با کنترل دسترسی',
    errorTitle: 'خطا در بارگذاری کاربران',
}
export const UserFormModalMeta: UserFormModalMetaProps = {
    title: 'ایجاد کاربر جدید',
    nameLabel: 'نام کامل',
    namePlaceholder: 'نام کامل را وارد کنید',
    emailLabel: 'ایمیل',
    emailPlaceholder: 'آدرس ایمیل را وارد کنید',
    roleLabel: 'نقش',
    rolePlaceholder: 'نقش را انتخاب کنید',
    submitButton: 'ایجاد کاربر',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد کاربر ناموفق بود. لطفاً دوباره تلاش کنید.',
    usernameLabel: 'نام کاربری',
    usernamePlaceholder: 'نام کاربری',
}

export const UpdateUserFormMeta: UpdateUserFormMetaProps = {
    title: 'ویرایش کاربر',
    submitButton: 'به‌روزرسانی کاربر',
    submittingButton: 'در حال به‌روزرسانی...'
}
export const DeleteUserMeta: DeleteUserMetaProps = {
    deleteButtonText: 'حذف کاربر',
    confirmTitle: 'حذف کاربر',
    confirmMessage: 'آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟ این اقدام قابل بازگشت نیست و کاربر انتخاب شده را حذف می‌کند.'
}
export const DEFAULT_FILTERS: VolunteerFiltersWithConflictProps = {
    name: "",
    email: "",
    phone_number: "",
    id: "",
    country: "eu",
    age: null,
    country_of_birth: "",
    family_origin: "",
    jamat_khana: "",
    iv_position: "",
    ismaili: null,
    registered_volunteer: null,
    profile_submitted: true,
    approved_volunteer: null,
    eligible_for_duty: true,
    multi_faith_family: null,
    has_support_needs: null,
    tags: [],
    preferences: [],
    languages: [],
    service_record: [],
    genders: [],
    trainings: [],
    training_filter_type: 'at_least_one',
    age_start: 18,
    age_end: null,
    conflict: null,
    status: null,
    volunteer_for_visit: 1,
    iiuk_registeration: "any", // "iiuk"
    availability: [],
    availability_filter_type: 'at_least_one',
    event_assignment_type: null,
    event_assignment_events: [],
    documents: [],
    allocation_status: [],
    core_team_assignment_type: null,
    clusters: []
};

export const LeadAssignModalMeta: LeadAssignModalPropsMeta = {
    cancelButton: "لغو",
    selectButton: "انتخاب",
    nameSearchPlaceholder: 'جستجو بر اساس نام...',
    emailSearchPlaceholder: 'جستجو بر اساس ایمیل...',
    phoneSearchPlaceholder: 'جستجو بر اساس تلفن...',
    idSearchPlaceholder: 'جستجو بر اساس شناسه...',
    searchButton: 'جستجو',
    clearButton: 'پاک کردن',
    showingLabel: 'نمایش',
    volunteersLabel: 'داوطلبان',
    noResultsMessage: 'هیچ داوطلبی مطابق با جستجوی شما یافت نشد',
    noVolunteersMessage: 'هیچ داوطلبی در دسترس نیست',
    idColumn: 'شناسه',
    nameColumn: 'نام',
    phoneColumn: 'تلفن',
    emailColumn: 'ایمیل',
    jamatKhanaColumn: 'جماعت‌خانه',
    duplicationsColumn: 'تکرارها',
    viewDuplicationsButton: (count: number) => `مشاهده (${count})`,
    actionColumn: 'اقدام',
    duplicationsModalTitle: (firstName: string, lastName: string) => `تکرارها برای ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `تخصیص‌های شیفت (${count})`,
    excludedAllocationsTitle: (count: number) => `مستثنی شده از شمارش تکراری (${count})`,
    excludedAllocationsDescription: 'این تخصیص‌ها از رویدادهایی هستند که در بررسی‌های تکراری لحاظ نمی‌شوند.',
    coreTeamAssignmentsTitle: (count: number) => `تخصیص‌های تیم اصلی (${count})`,
    leadPositionsTitle: (count: number) => `موقعیت‌های سرگروه/جانشین سرگروه (${count})`,
    excludedLeadPositionsTitle: (count: number) => `موقعیت‌های سرگروه مستثنی شده (${count})`,
    excludedLeadPositionsDescription: 'این موقعیت‌های سرگروه از رویدادهایی هستند که در بررسی‌های تکراری لحاظ نمی‌شوند.',
    positionTypeColumn: 'نوع',
    statusColumn: 'وضعیت',
    eventColumn: 'رویداد',
    areaColumn: 'بخش',
    shiftColumn: 'شیفت',
    dateTimeColumn: 'تاریخ/زمان',
    noDuplicationsMessage: 'هیچ تخصیص دیگر یا تخصیص تیم اصلی یافت نشد.',
    closeModalButton: 'بستن',
    submittedStatus: 'ارسال شده',
    approvedStatus: 'تأیید شده',
    pendingStatus: 'در انتظار',
    acceptedStatus: 'پذیرفته شده',
    declinedStatus: 'رد شده',
    roleColumn: 'نقش',
    streamsColumn: 'جریان‌ها'
}

export const AccessColorMeta: AccessColorMetaProps = {
    title: 'رنگ‌های دسترسی',
    description: 'مدیریت تمام رنگ‌های دسترسی.',
    createButton: 'ایجاد جدید',
    submitButton: 'ایجاد',
    submittingButton: 'در حال ایجاد...',
    errorTitle: 'دریافت رنگ‌های دسترسی ناموفق بود',
    noAnnouncementsMessage: 'هنوز هیچ رنگ دسترسی ایجاد نشده است.',
    backButton: 'بازگشت به مرکز مدیریت',
    onDeleteTitle: 'حذف رنگ دسترسی',
    onDeleteMessage: 'حذف این دسترسی آن را برای تمام کاربران به‌طور دائمی پاک می‌کند. این اقدام قابل بازگشت نیست.'
}

export const AccessColorFormModalMeta: AccessColorFormModalMetaProps = {
    title: 'ایجاد رنگ دسترسی جدید',
    submitButton: 'ایجاد رنگ',
    submittingButton: 'در حال ایجاد...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    errorMessage: 'ایجاد رنگ دسترسی ناموفق بود. لطفاً دوباره تلاش کنید.',
    colorLabel: 'رنگ انتخاب شده',
    presetColorLabel: "رنگ‌های از پیش‌تنظیم شده",
    updateButton: 'به‌روزرسانی رنگ',
    updatingButton: 'در حال به‌روزرسانی رنگ'

}

export const COLOR_PRESETS = [
    '#EF4444', // red
    '#F97316', // orange
    '#FACC15', // yellow
    '#22C55E', // green
    '#3B82F6', // blue
    '#6366F1', // indigo
    '#8B5CF6', // purple
    '#EC4899', // pink
    '#6B7280', // gray
];

export const AVAILABILITY_OPTIONS = [
    "Setup Support (3rd July)",
    "Pre Didar (4th July)",
    "Didar Day (5th July)",
    "Post Didar (6th July)"
] as const


export const VOLUNTEER_FOR_VISIT_MAP = {
    1: "بله، می‌خواهم داوطلب شوم",
    0: "خیر، در این زمان در دسترس نیستم",
    null: "بدون انتخاب" // default case
} as const

export const VOLUNTEER_FOR_VISIT_MAP_INVERSE = {
    "بله، می‌خواهم داوطلب شوم": 1,
    "خیر، در این زمان در دسترس نیستم": 0,
    "مشخص نشده": "null",
} as const

export const TrainingSequenceEditMeta: TrainingSequenceEditMetaProps = {
    title: 'ویرایش ترتیب آموزش',
    message: 'آموزش‌ها را برای تغییر ترتیب آن‌ها بکشید.',
    cancelButton: 'لغو',
    submitButton: 'به‌روزرسانی',
    submittingButton: 'در حال به‌روزرسانی...'
}

export const VolunteerOverviewMeta: VolunteerOverviewMetaProps = {
    title: 'خلاصه داوطلبان',
    description: 'نمای کلی آمار جمعیتی داوطلبان',
    errorTitle: 'خطا در هنگام دریافت اطلاعات داوطلب',
    loadingText: 'در حال بارگذاری'
}

export const TrainingsOverviewMeta: TrainingsOverviewMetaProps = {
    title: 'نمای کلی آموزش‌ها',
    description: 'نمای کلی تخصیص‌های آموزشی',
    loadingText: 'در حال بارگذاری...',
    errorTitle: 'خطا در بارگذاری داده‌های آموزشی'
}

export const AllocationsOverviewMeta: AllocationsOverviewMetaProps = {
    title: 'خلاصه تخصیص‌ها',
    description: 'نمای کلی آمار جمعیتی تخصیص‌ها',
    eventsCardTitle: 'مجموع رویدادها',
    areaCardTitle: 'مجموع بخش‌ها',
    shiftCardTitle: 'مجموع شیفت‌ها',
    volunteersCardTitle: 'مجموع داوطلبان',
    allocationsCardTitle: 'مجموع تخصیص‌ها',
    allocationStatusTitle: 'وضعیت تخصیص',
    pendingLabel: 'در انتظار',
    acceptedLabel: 'پذیرفته شده',
    declinedLabel: 'رد شده',
    loadingText: 'در حال بارگذاری داشبورد...',
    errorTitle: 'خطا در بارگذاری داشبورد'
}

export const CoreStreamOverviewMeta: CoreStreamOverviewMetaProps = {
    title: 'نمای کلی جریان‌های تیم اصلی',
    description: 'نمای کلی تخصیص‌های جریان تیم اصلی',
    loadingText: 'در حال بارگذاری...',
    errorTitle: 'خطا در بارگذاری داده‌های تیم اصلی',
    noDataMessage: 'هیچ داده جریان اصلی موجود نیست.'
}

export const VolunteerStatsTableOverviewMeta: VolunteerStatsTableOverviewMetaProps = {
    title: 'آمار داوطلبان',
    description: 'نمای کلی آمار جمعیتی داوطلبان',
    loadingText: 'در حال بارگذاری...',
    errorTitle: 'خطا در بارگذاری داده‌های آماری.',
    noDataMessage: 'هیچ داده آماری موجود نیست.'
}

export const DidarAcknowledgementOverviewMeta: DidarAcknowledgementOverviewMetaProps = {
    title: 'نمای کلی تأییدیه دیدار',
    description: 'نمای کلی تأییدیه‌های دیدار',
    loadingText: 'در حال بارگذاری...',
    errorTitle: 'خطا در بارگذاری داده‌های تأییدیه.',
    noDataMessage: 'هیچ داده تأییدیه‌ای موجود نیست.'
}


export const DashboardMeta: DashboardMetaProps = {
    title: 'داشبورد',
    description: 'نمای کلی کاربران، داوطلبان و تخصیص‌ها',
    eventsCardTitle: 'مجموع رویدادها',
    areaCardTitle: 'مجموع بخش‌ها',
    shiftCardTitle: 'مجموع شیفت‌ها',
    volunteersCardTitle: 'مجموع داوطلبان',
    allocationsCardTitle: 'مجموع تخصیص‌ها',
    allocationStatusTitle: 'وضعیت تخصیص',
    pendingLabel: 'در انتظار',
    acceptedLabel: 'پذیرفته شده',
    declinedLabel: 'رد شده',
    loadingText: 'در حال بارگذاری داشبورد...',
    errorTitle: 'خطا در بارگذاری داشبورد'
}


export const MangementAnalyticsMeta: ManagementAnalyticsMetaProps = {
    title: 'آمار',
    description: 'نماها و فیلترها',
    errorTitle: 'خطا در هنگام دریافت اطلاعات داده‌ها',
    loadingText: 'در حال بارگذاری...'
}

export const CHART_COLORS = [
    "#2563eb", // blue
    "#16a34a", // green
    "#f59e0b", // amber
    "#dc2626", // red
    "#7c3aed", // violet
    "#0891b2", // cyan
    "#9333ea", // purple
    "#65a30d", // lime
    "#0f766e", // teal
    "#be123c", // rose
    "#ea580c", // orange
    "#1d4ed8", // indigo
    "#15803d", // dark green
    "#854d0e", // brown/gold
    "#9f1239", // dark rose
    "#0369a1", // sky blue
    "#4d7c0f", // olive
    "#6b21a8", // deep purple
    "#b91c1c", // dark red
    "#0f172a", // slate (near-black)
];




export const CHART_HEIGHT_MAP: Record<MaxChartSize, number> = {
    sm: 220,
    md: 260,
    lg: 300,
    xl: 340,
    '2xl': 380,
    '3xl': 420,
    '4xl': 460,
    '5xl': 520,
    '6xl': 580,
    '7xl': 640,
    '8xl': 720,
    '9xl': 800,
    '10xl': 880,
};

export const CHART_WIDTH_CLASSES: Record<MaxChartSize, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    '8xl': 'max-w-8xl',
    '9xl': 'max-w-9xl',
    '10xl': 'max-w-10xl',
};

export const ANALYTICS_TABS: { key: AnalyticsTab; label: string }[] = [
    { key: "dashboard", label: "داشبورد" },
    { key: "trainings", label: "نمای کلی آموزش‌ها" },
    { key: "volunteers", label: "آمار جمعیتی داوطلبان" },
    { key: "volunteertable", label: "آمار داوطلبان" },
    { key: "didar", label: "تأییدیه‌های دیدار" },
    { key: "iff", label: "آمار جمعیتی خانواده‌های چند‌دینی" },
    { key: "non-iiuk", label: "آمار جمعیتی داوطلبان غیر IIUK" },
    { key: 'duty_acceptance', label: "آمار پذیرش وظیفه" },
    { key: 'check-in', label: 'آمار جمعیتی اعلام حضور' },
];

export const InternationalRegisterationsMeta: InternationalRegisterationsMetaProps = {
    title: "ثبت‌نام‌های بین‌المللی",
    description: "ثبت‌نام‌های بین‌المللی زیر دریافت شده است.",
    errorTitle: "خطا در هنگام دریافت ثبت‌نام‌های بین‌المللی رخ داد.",
    noDataMessage: "هیچ ثبت‌نامی موجود نیست.",
    loadingText: "در حال بارگذاری درخواست ثبت‌نام",
    exportButton: "خروجی CSV",
    lastSignInColumn: "آخرین ورود",
    neverSignedInText: "هرگز وارد نشده است",
}

export const ShiftStatusMap = {
    0: 'باز',
    1: 'در حال بررسی',
    2: 'تأیید شده',
    3: 'رد شده'
}

export const EmailCampaignsMeta: EmailCampaignsMetaProps = {
    title: 'کمپین‌های ایمیل',
    description: 'ایجاد و مدیریت ایمیل‌های گروهی به داوطلبان',
    createButton: 'ایجاد کمپین',
    subjectLabel: 'موضوع',
    statusLabel: 'وضعیت',
    recipientsLabel: 'گیرندگان',
    progressLabel: 'پیشرفت',
    createdLabel: 'ایجاد شده',
    actionsLabel: 'اقدامات',
    editButton: 'ویرایش',
    deleteButton: 'حذف',
    viewButton: 'مشاهده',
    statusDraft: 'پیش‌نویس',
    statusTestSent: 'تست ارسال شد',
    statusPendingApproval: 'در انتظار تأیید',
    statusSending: 'در حال ارسال',
    statusCompleted: 'تکمیل شده',
    statusFailed: 'ناموفق',
    pendingApprovalCountLabel: (count) => `${count} در انتظار تأیید`,
    showPendingApprovalOnlyLabel: 'فقط موارد در انتظار تأیید را نشان بده',
    showAllCampaignsLabel: 'نمایش همه کمپین‌ها',
    noPendingApprovalCampaignsMessage: 'در حال حاضر هیچ کمپینی در انتظار تأیید نیست.',
    noCampaignsMessage: 'هیچ کمپین ایمیلی یافت نشد. برای شروع، اولین کمپین خود را ایجاد کنید.',
    loadingText: 'در حال بارگذاری کمپین‌ها...',
    errorTitle: 'خطا در بارگذاری کمپین‌ها',
    deleteConfirmTitle: 'حذف کمپین',
    deleteConfirmMessage: 'آیا مطمئن هستید که می‌خواهید این کمپین را حذف کنید؟ این اقدام قابل بازگشت نیست.',
    cancelButton: 'لغو',
    confirmDeleteButton: 'حذف کمپین',
    exportRecipientsButton: 'خروجی گیرندگان'
}

export const EmailCampaignFormMeta: EmailCampaignFormMetaProps = {
    createTitle: 'ایجاد کمپین ایمیل',
    editTitle: 'ویرایش کمپین ایمیل',
    subjectLabel: 'موضوع ایمیل',
    subjectPlaceholder: 'موضوع ایمیل را وارد کنید...',
    bodyLabel: 'متن ایمیل',
    bodyPlaceholder: 'پیام ایمیل خود را بنویسید...',
    saveDraftButton: 'ذخیره پیش‌نویس',
    cancelButton: 'لغو',
    previewButton: 'پیش‌نمایش',
    sendTestButton: 'ارسال تست',
    sendCampaignButton: 'ارسال کمپین',
    submitForApprovalButton: 'ارسال برای تأیید',
    approveCampaignButton: 'تأیید و ارسال',
    denyCampaignButton: 'رد و بازگشایی',
    testEmailsLabel: 'آدرس‌های ایمیل تست',
    testEmailsPlaceholder: 'email@example.com',
    testEmailsHint: 'حداکثر 10 آدرس ایمیل برای ارسال ایمیل‌های تست وارد کنید',
    addEmailButton: 'افزودن ایمیل',
    removeEmailButton: 'حذف',
    confirmSendTitle: 'ارسال کمپین ایمیل',
    confirmSendMessage: (count) => `شما در حال ارسال این ایمیل به ${count} گیرنده هستید. این اقدام قابل بازگشت نیست. آیا مطمئن هستید؟`,
    confirmSubmitTitle: 'ارسال کمپین برای تأیید',
    confirmSubmitMessage: (count) => `این کمپین را با ${count} گیرنده قابل ارسال برای تأیید ارسال می‌کنید؟ محتوا و گیرندگان قفل خواهند شد.`,
    confirmApproveTitle: 'تأیید و ارسال کمپین',
    confirmApproveMessage: (count) => `این کمپین را تأیید کرده و ارسال به ${count} گیرنده را شروع می‌کنید؟ این اقدام قابل بازگشت نیست.`,
    confirmDenyTitle: 'رد کمپین',
    confirmDenyMessage: 'این کمپین رد شود و برای ویرایش دوباره باز شود؟ ایجادکننده می‌تواند محتوا و گیرندگان را پیش از ارسال دوباره برای تأیید به‌روزرسانی کند.',
    confirmDenyButton: 'رد کمپین',
    noTestSentWarning: 'هشدار: شما هنوز هیچ ایمیل تستی ارسال نکرده‌اید. توصیه می‌شود قبل از ارسال به همه داوطلبان، ایمیل‌های تست ارسال کنید.',
    confirmButton: 'تأیید ارسال',
    errorSaving: 'ذخیره کمپین ناموفق بود',
    errorLoading: 'بارگذاری کمپین ناموفق بود',
    successSaved: 'کمپین با موفقیت ذخیره شد',
    successTestSent: 'ایمیل(های) تست با موفقیت ارسال شد',
    successSent: 'کمپین در حال ارسال است',
    successSubmitted: 'کمپین برای تأیید ارسال شد',
    successDenied: 'کمپین رد شد و برای ویرایش دوباره باز شد',
    contentLockedPendingApproval: 'این کمپین برای تأیید ارسال شده است. محتوا و گیرندگان تا زمانی که تأییدکننده ارسال را شروع کند قفل هستند.',
    // Targeting criteria
    targetingTitle: 'افزودن گیرندگان بر اساس گروه',
    targetingDescription: 'برای افزودن گروهی از گیرندگان، یک روش هدف‌گذاری را انتخاب کنید',
    allVolunteersLabel: 'همه داوطلبان دارای پروفایل ارسال شده',
    targetEventLabel: 'فیلتر بر اساس رویداد (اختیاری)',
    targetAreaLabel: 'فیلتر بر اساس بخش (اختیاری)',
    targetShiftLabel: 'فیلتر بر اساس شیفت (اختیاری)',
    targetDutyLabel: 'فیلتر بر اساس نوع وظیفه (اختیاری)',
    selectEventPlaceholder: 'همه رویدادها (همه داوطلبان)',
    selectAreaPlaceholder: 'همه بخش‌ها در این رویداد',
    selectShiftPlaceholder: 'همه شیفت‌ها در این بخش',
    selectDutyPlaceholder: 'همه انواع وظایف',
    loadingEvents: 'در حال بارگذاری رویدادها...',
    loadingAreas: 'در حال بارگذاری بخش‌ها...',
    loadingShifts: 'در حال بارگذاری شیفت‌ها...',
    loadingDuties: 'در حال بارگذاری وظایف...',
    includeLeadsLabel: 'همچنین شامل سرگروه‌ها:',
    includeEventLeadsLabel: 'سرگروه‌های رویداد',
    includeAreaLeadsLabel: 'سرگروه‌ها/جانشینان بخش',
    includeShiftLeadsLabel: 'سرگروه‌ها/جانشینان شیفت',
    // Volunteer types and volunteer filters for "all volunteers" option
    volunteerTypesLabel: 'انواع داوطلب',
    volunteerTypeIiukUkIreland: 'ثبت‌نام شده IIUK (محلی - اروپا)',
    volunteerTypeIiukEurope: 'ثبت‌نام شده IIUK (بین‌المللی)',
    volunteerTypeNonIiuk: 'جامعه داوطلبان (غیر IIUK)',
    volunteerForVisitLabel: 'داوطلب شدن در طول دیدار',
    volunteerForVisitYes: 'داوطلب شدن در طول دیدار (در دسترس بودن را اعلام کرده‌اند)',
    volunteerForVisitNo: 'خیر - برای داوطلبی در دسترس نیستم',
    volunteerForVisitBoth: 'هر دو (همه پاسخ‌ها)',
    // Recipient management
    recipientManagementTitle: 'مدیریت گیرندگان',
    recipientManagementDescription: 'گیرندگان را به‌صورت فردی یا گروهی اضافه کنید. موارد تکراری به‌طور خودکار حذف می‌شوند.',
    recipientSourceHistoryTitle: 'سابقه منبع گیرندگان',
    recipientSourceHistoryDescription: 'پیش از تأیید این کمپین، بررسی کنید گیرندگان چگونه اضافه شده‌اند.',
    recipientSourceNoHistory: 'برای این کمپین سابقه منبعی ثبت نشده است. ممکن است قبل از اضافه شدن ردیابی ایجاد شده باشد.',
    recipientSourceAddedLabel: 'اضافه شده',
    recipientSourceSelectedLabel: 'انتخاب شده',
    recipientSourceDuplicatesLabel: 'موارد تکراری رد شده',
    recipientSourceWithoutEmailLabel: 'بدون ایمیل',
    recipientSourceTotalAfterLabel: 'مجموع پس از تغییر',
    recipientSourceAddedByLabel: 'توسط',
    recipientSourceShowButton: 'نمایش سابقه',
    recipientSourceHideButton: 'پنهان کردن سابقه',
    recipientListTitle: 'لیست گیرندگان',
    noRecipientsMessage: 'هنوز هیچ گیرنده‌ای اضافه نشده است. برای افزودن گیرندگان از دکمه‌های بالا استفاده کنید.',
    addGroupButton: 'افزودن گروه',
    addIndividualButton: 'افزودن فرد',
    clearAllButton: 'پاک کردن همه',
    recipientCountLabel: (count) => `${count} گیرنده`,
    removeRecipientButton: 'حذف',
    searchVolunteersPlaceholder: 'جستجوی داوطلبان بر اساس نام...',
    addSelectedButton: 'افزودن انتخاب شده‌ها',
    groupAddedMessage: (added, total) => `${added} گیرنده جدید اضافه شد. مجموع: ${total}`,
    individualAddedMessage: (added, total) => `${added} گیرنده اضافه شد. مجموع: ${total}`,
    clearConfirmTitle: 'پاک کردن تمام گیرندگان',
    clearConfirmMessage: 'آیا مطمئن هستید که می‌خواهید همه گیرندگان را از این کمپین حذف کنید؟',
    confirmClearButton: 'پاک کردن همه',
    // Email suggestions
    emailSuggestionsTitle: 'تنظیم آدرس ایمیل',
    emailSuggestionsDescription: 'یک آدرس ایمیل انتخاب کنید برای',
    customEmailLabel: 'ایمیل سفارشی را وارد کنید',
    saveButton: 'ذخیره',
    noEmailSuggestions: 'هیچ پیشنهادی در دسترس نیست. لطفاً یک ایمیل به‌صورت دستی وارد کنید.',
    // Retry failed
    retryFailedButton: 'تلاش مجدد ناموفق‌ها',
    retryFailedConfirmTitle: 'تلاش مجدد برای ایمیل‌های ناموفق',
    retryFailedConfirmMessage: (count: number) => `شما در حال تلاش مجدد برای ارسال به ${count} گیرنده ناموفق هستید. ادامه می‌دهید؟`,
    confirmRetryButton: 'تلاش مجدد',
    successRetry: (count: number) => `تلاش مجدد برای ${count} ایمیل ناموفق...`
}

export const EmailCampaignPreviewMeta: EmailCampaignPreviewMetaProps = {
    title: 'پیش‌نمایش ایمیل',
    closeButton: 'بستن',
    backButton: 'بازگشت به ویرایش',
    testWarningTitle: 'اعلامیه ایمیل تست',
    testWarningMessage: 'این بنر فقط در ایمیل‌های تست ظاهر می‌شود. در کمپین اصلی گنجانده نخواهد شد.'
}

export const ShiftMoveModalMeta: ShiftMoveModalMetaProps = {
    title: "انتقال داوطلب",
    submitButton: "انتقال",
    submittingButton: "در حال انتقال...",
    closeButton: "لغو",
    eventLabel: "رویداد",
    areaLabel: "بخش",
    shiftLabel: "شیفت",
    eventPlaceHolder: "انتخاب رویداد",
    areaPlaceHolder: "انتخاب بخش",
    shiftPlaceHolder: "انتخاب شیفت"
}


export const VolunteerUploadDocumentFormMeta: VolunteerUploadDocumentFormMetaProps = {
    title: "آپلود سند",
    cancelButton: "لغو",
    submitButton: "آپلود",
    submittingButton: "در حال آپلود...",
    documentTypeLabel: "نوع سند"
}

export const UPLOAD_DOCUMENT_TYPES = ["DBS (استاندارد)", "DBS (پیشرفته)", "کمک‌های اولیه", "گواهی پزشکی"]

export const AllocationStatusPageMeta: AllocationStatusPageMetaProps = {
    title: 'مدیریت پذیرش وظیفه',
    description: 'مشاهده و مدیریت وضعیت‌های پذیرش وظیفه داوطلبان، فیلتر کردن بر اساس معیارهای مختلف، و تخصیص مجدد داوطلبان در صورت نیاز.',
    backLink: '← بازگشت به مرکز مدیریت',
    // Status badges
    pendingLabel: 'در انتظار',
    acceptedLabel: 'پذیرفته شده',
    declinedLabel: 'رد شده',
    allLabel: 'همه',
    // Filter labels
    filtersTitle: 'فیلترها',
    statusFilterLabel: 'وضعیت',
    eventFilterLabel: 'رویداد',
    areaFilterLabel: 'بخش',
    shiftFilterLabel: 'شیفت',
    volunteerSearchLabel: 'جستجوی داوطلب',
    volunteerSearchPlaceholder: 'جستجو بر اساس نام، ایمیل یا شناسه...',
    declineReasonFilterLabel: 'دلیل رد کردن',
    dateRangeLabel: 'محدوده تاریخ پاسخ',
    dateFromLabel: 'از',
    dateToLabel: 'تا',
    offeredAsTknLabel: 'ارائه شده به عنوان TKN',
    // Volunteer count filters
    volunteerCountsTitle: 'فیلتر بر اساس تعداد پاسخ داوطلب',
    volunteerCountsEventsLabel: 'شمارش پاسخ‌ها در رویدادها:',
    volunteerCountsEventsAllLabel: 'همه رویدادها',
    minPendingCountLabel: 'حداقل در انتظار',
    maxPendingCountLabel: 'حداکثر در انتظار',
    minAcceptedCountLabel: 'حداقل پذیرفته شده',
    maxAcceptedCountLabel: 'حداکثر پذیرفته شده',
    minDeclinedCountLabel: 'حداقل رد شده',
    maxDeclinedCountLabel: 'حداکثر رد شده',
    // Filter placeholders
    selectEventPlaceholder: 'همه رویدادها',
    selectAreaPlaceholder: 'همه بخش‌ها',
    selectShiftPlaceholder: 'همه شیفت‌ها',
    selectDeclineReasonPlaceholder: 'همه دلایل',
    // Actions
    searchButton: 'جستجو',
    clearFiltersButton: 'پاک کردن فیلترها',
    exportCsvButton: 'خروجی CSV',
    exportingButton: 'در حال خروجی گرفتن...',
    // Table
    tableVolunteerColumn: 'داوطلب',
    tableEventColumn: 'رویداد',
    tableAreaColumn: 'بخش',
    tableShiftColumn: 'شیفت',
    tableStatusColumn: 'وضعیت',
    tableTknColumn: 'TKN',
    tableDeclineReasonColumn: 'دلیل رد کردن',
    tableResponseDateColumn: 'تاریخ پاسخ',
    tableActionsColumn: 'اقدامات',
    // Bulk actions
    bulkActionsTitle: 'اقدامات گروهی',
    selectedCountLabel: (count) => `${count} انتخاب شده`,
    changeStatusButton: 'تغییر وضعیت',
    reAllocateButton: 'تخصیص مجدد',
    setToPendingButton: 'تنظیم روی در انتظار',
    setToAcceptedButton: 'تنظیم روی پذیرفته شده',
    setToDeclinedButton: 'تنظیم روی رد شده',
    // Messages
    noResultsMessage: 'هیچ تخصیصی مطابق با معیارهای شما یافت نشد.',
    loadingMessage: 'در حال بارگذاری تخصیص‌ها...',
    errorMessage: 'خطایی در هنگام بارگذاری تخصیص‌ها رخ داد.',
    bulkUpdateSuccessMessage: (count) => `با موفقیت ${count} تخصیص به‌روزرسانی شد.`,
    bulkUpdateErrorMessage: 'به‌روزرسانی تخصیص‌ها ناموفق بود. لطفاً دوباره تلاش کنید.',
    // Re-allocate modal
    reAllocateTitle: 'تخصیص مجدد داوطلب(ان)',
    reAllocateDescription: 'یک شیفت جدید را برای تخصیص داوطلب(ان) انتخاب شده برگزینید. این کار یک تخصیص جدید ایجاد می‌کند بدون اینکه روی تخصیص اصلی تأثیر بگذارد.',
    reAllocateEventLabel: 'رویداد',
    reAllocateAreaLabel: 'بخش',
    reAllocateShiftLabel: 'شیفت',
    reAllocateWarning: 'نکته: تخصیص اصلی بدون تغییر باقی خواهد ماند. این یک تخصیص جدید با وضعیت در انتظار ایجاد می‌کند.',
    reAllocateDuplicateWarning: 'هشدار: یک یا چند داوطلب در حال حاضر تخصیصی برای این شیفت دارند.',
    reAllocateSubmitButton: 'ایجاد تخصیص جدید',
    reAllocatingButton: 'در حال ایجاد...',
    reAllocateCancelButton: 'لغو',
    reAllocateSuccessMessage: (count) => `با موفقیت ${count} تخصیص جدید ایجاد شد.`,
    reAllocateErrorMessage: 'ایجاد تخصیص‌های جدید ناموفق بود. لطفاً دوباره تلاش کنید.',
    // Pagination
    previousButton: 'قبلی',
    nextButton: 'بعدی',
    pageLabel: 'صفحه',
    itemsPerPageLabel: 'موارد در هر صفحه',
    totalItemsLabel: (count) => `${count} مورد کل`,
    // Decline reasons (copied from Home for consistency)
    declineReasons: [
        'زمان‌بندی مناسب نیست (ممکن است شیفت دیگری بسته به در دسترس بودن پیشنهاد شود)',
        'تمایلی به انجام این وظیفه خاص ندارم (ممکن است شیفت دیگری بسته به در دسترس بودن پیشنهاد شود)',
        'در این زمان قادر به تعهد نیستم (در روز مربوطه به VRC مراجعه خواهم کرد)',
        'به دلایل شخصی دیگر مایل به ادامه نیستم'
    ],
    startTimeLabel: 'زمان شروع',
    endTimeLabel: 'زمان پایان'
}

export const ALLOCATION_STATUS_OPTIONS = ["Accepted", "Declined", "Pending"]

export const CheckInPageMeta: CheckInPageMetaProps = {
    title: 'اعلام حضور داوطلب',
    description: 'نشان‌های داوطلبان را اسکن کنید یا با جستجوی نام، حضور آن‌ها را برای وظایف محول شده ثبت کنید.',
    backToAdmin: 'بازگشت به مدیریت',
    // Mode toggle
    scanModeLabel: 'اسکن نشان',
    searchModeLabel: 'جستجو',
    // Scanner input
    scannerPlaceholder: 'اسکن نشان یا وارد کردن بارکد...',
    scannerLabel: 'اسکنر نشان',
    scannerHint: 'بارکد نشان را مقابل اسکنر قرار دهید',
    // Search input
    searchPlaceholder: 'جستجو بر اساس نام، ایمیل یا شناسه...',
    searchLabel: 'جستجوی داوطلب',
    searchHint: 'حداقل ۲ کاراکتر برای جستجو وارد کنید',
    searchButton: 'جستجو',
    searchingText: 'در حال جستجو...',
    searchResultsTitle: 'نتایج جستجو',
    noSearchResultsMessage: 'هیچ داوطلبی مطابق با جستجوی شما یافت نشد.',
    selectVolunteerButton: 'انتخاب',
    // Event filter
    eventFilterLabel: 'انتخاب رویداد',
    selectEventPrompt: 'لطفاً یک رویداد انتخاب کنید',
    // Volunteer display
    volunteerNotFoundMessage: 'داوطلب یافت نشد. لطفاً دوباره اسکن کنید.',
    loadingMessage: 'در حال جستجوی داوطلب...',
    errorMessage: 'خطایی رخ داد. لطفاً دوباره تلاش کنید.',
    scanToBeginMessage: 'برای شروع اعلام حضور، یک نشان داوطلب را اسکن کنید',
    searchToBeginMessage: 'برای شروع اعلام حضور، یک داوطلب را بر اساس نام جستجو کنید',
    // Volunteer card
    volunteerCardTitle: 'جزئیات داوطلب',
    emailLabel: 'ایمیل',
    phoneLabel: 'تلفن',
    countryLabel: 'کشور',
    jamatkhanaLabel: 'جماعت‌خانه',
    // Allocations
    allocationsTitle: 'تخصیص‌های وظیفه',
    noAllocationsMessage: 'هیچ تخصیص وظیفه‌ای برای این داوطلب یافت نشد.',
    noAllocationsForEventMessage: 'هیچ تخصیصی برای رویداد انتخاب شده وجود ندارد.',
    eventColumn: 'رویداد',
    areaColumn: 'بخش',
    shiftColumn: 'شیفت',
    timeColumn: 'زمان',
    statusColumn: 'پذیرش',
    actionColumn: 'اعلام حضور',
    // Check-in status
    checkedInLabel: 'اعلام حضور شده',
    notCheckedInLabel: 'حضور اعلام نشده',
    checkedInAtLabel: (time) => `اعلام حضور در ${time}`,
    checkedInByLabel: (name) => `توسط ${name}`,
    // Buttons
    checkInButton: 'اعلام حضور',
    undoCheckInButton: 'لغو اعلام حضور',
    checkingInButton: 'در حال ثبت...',
    deallocateDutyButton: 'حذف تخصیص',
    deallocatingDutyButton: 'در حال حذف...',
    scanAnotherButton: 'اسکن بعدی',
    allocateDutyButton: 'تخصیص وظیفه',
    // Messages
    checkInSuccessMessage: 'اعلام حضور با موفقیت انجام شد!',
    undoCheckInSuccessMessage: 'اعلام حضور لغو شد.',
    deallocateDutyConfirmMessage: (dutyName) => `حذف ${dutyName} از این داوطلب؟ این عمل قابل بازگشت نیست.`,
    deallocateDutySuccessMessage: 'تخصیص وظیفه با موفقیت حذف شد.',
    deallocateDutyErrorMessage: 'حذف تخصیص وظیفه ناموفق بود. لطفاً دوباره تلاش کنید.',
    checkInErrorMessage: 'اعلام حضور ناموفق بود. لطفاً دوباره تلاش کنید.',
    // Allocation status badges
    pendingStatusLabel: 'در انتظار',
    acceptedStatusLabel: 'پذیرفته شده',
    declinedStatusLabel: 'رد شده',
    // Camera scanning
    cameraScanButton: 'استفاده از دوربین',
    cameraScannerTitle: 'اسکن نشان با دوربین',
    cameraScannerHint: 'بارکد نشان را در نمای دوربین قرار دهید',
    cameraPermissionDenied: 'دسترسی به دوربین رد شد. لطفاً دسترسی به دوربین را برای استفاده از این ویژگی مجاز کنید.',
    cameraNotSupported: 'اسکن با دوربین در این دستگاه پشتیبانی نمی‌شود.',
    closeCameraButton: 'بستن',
    // Shift View mode
    shiftViewModeLabel: 'نمای شیفت',
    shiftViewAreaLabel: 'بخش',
    shiftViewShiftLabel: 'شیفت',
    shiftViewSelectAreaPrompt: 'یک بخش انتخاب کنید',
    shiftViewSelectShiftPrompt: 'یک شیفت انتخاب کنید',
    shiftViewNoAreasMessage: 'هیچ بخشی برای رویدادهای انتخاب شده یافت نشد.',
    shiftViewNoShiftsMessage: 'هیچ شیفتی برای بخش انتخاب شده یافت نشد.',
    shiftViewLoadingVolunteers: 'در حال بارگذاری داوطلبان...',
    shiftViewNoVolunteersMessage: 'هیچ داوطلبی به این شیفت اختصاص داده نشده است.',
    shiftViewVolunteerCount: (checked, total) => `${checked}/${total} حضور یافته`,
    shiftViewNameColumn: 'نام',
    shiftViewPhoneColumn: 'تلفن',
    shiftViewTimeColumn: 'بازه زمانی',
    shiftViewStatusColumn: 'وضعیت',
    shiftViewActionColumn: 'اقدام',
    // Create volunteer
    createVolunteerButton: "پیدا نمی‌کنید؟ اینجا ایجاد کنید"
}

export const DutyStatusOverviewMeta: DutyStatusOverviewMetaProps = {
    title: "آمار پذیرش وظیفه",
    description: "جدول زیر تفکیک وضعیت پذیرش وظیفه برای شیفت‌های منتشر شده است.",
    errorTitle: "دریافت آمار ناموفق بود.",
    loadingText: "در حال بارگذاری...",
    eventSelectionLabel: "رویدادهایی را برای تجزیه و تحلیل انتخاب کنید"
}

export const QuickAllocateModalMeta: QuickAllocateModalMetaProps = {
    title: 'تخصیص سریع وظیفه',
    subtitle: (volunteerName) => `یک وظیفه به ${volunteerName} اختصاص دهید`,
    // Search
    searchPlaceholder: 'جستجوی شیفت‌ها یا بخش‌ها...',
    // Sort options
    sortLabel: 'مرتب‌سازی بر اساس',
    sortByUrgency: 'فوریت',
    sortByStartTime: 'زمان شروع',
    sortByAlphabetical: 'الفبایی',
    // Stats labels
    requiredLabel: 'مورد نیاز',
    acceptedLabel: 'پذیرفته شده',
    checkedInLabel: 'اعلام حضور شده',
    // Shift display
    noShiftsMessage: 'هیچ شیفت در دسترسی برای این رویداد یافت نشد.',
    loadingShiftsMessage: 'در حال بارگذاری شیفت‌ها...',
    viewOtherShiftsButton: (count) => `نمایش شیفت‌های دیگر (${count})`,
    hideOtherShiftsButton: 'پنهان کردن شیفت‌های دیگر',
    // Conflict labels
    alreadyAllocatedLabel: 'قبلاً تخصیص داده شده',
    timeConflictLabel: 'تداخل زمانی',
    // Buttons
    allocateButton: 'تخصیص',
    allocatingButton: 'در حال تخصیص...',
    cancelButton: 'لغو',
    closeButton: 'بستن',
    // Messages
    allocationSuccessMessage: 'وظیفه با موفقیت تخصیص داده شد!',
    allocationErrorMessage: 'تخصیص وظیفه ناموفق بود. لطفاً دوباره تلاش کنید.'
}

export const LiveOperationsMeta: LiveOperationsMetaProps = {
    title: "عملیات زنده رویداد",
    description: 'نظارت بر حضور داوطلبان در زمان واقعی، پوشش شیفت‌ها و معیارهای عملیاتی حیاتی.',
    errorTitle: 'خطا',
    areaCheckBoxTitle: 'انتخاب بخش‌ها',
    areaCheckBoxLabel: 'بخش‌ها را از شیفت‌هایی که می‌خواهید نمایش داده شوند، انتخاب کنید',
    shiftsMeta: { title: 'شیفت‌های موجود', description: 'شیفت‌های زیر به پشتیبانی داوطلبان نیاز دارند' }
}

export const LIVE_OPERATIONS_TABS: { key: LiveStatusTab, header: string }[] = [
    { key: "checkin-stats", header: "اعلام حضورها" },
    { key: "shifts", header: "شیفت‌های فوری" },
]

export const LoginFormMeta: LoginFormMetaProps = {
    title: 'ورود غیر IIUK',
    emailLabel: 'ایمیل',
    emailPlaceholder: 'name@company.com',
    passwordLabel: 'رمز عبور',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'رمز عبور خود را فراموش کرده‌اید؟',
    loginButton: 'ورود',
    createAccount: 'ایجاد حساب کاربری',
    errorLabel: 'خطا:',
    sending: 'در حال ارسال...',
    resendVerification: 'ارسال مجدد ایمیل تأیید',
    travelInfo: 'اگر قبلاً برنامه‌ریزی سفر دارید و می‌خواهید داوطلب شوید، لطفاً علاقه‌مندی خود را ثبت کنید. داوطلبی بر اساس ترتیبات شخصی است و تمام الزامات سفر، اقامت، ویزا و موارد مرتبط باید به طور مستقل ترتیب داده شود.'
}

export const ForgetPasswordMeta: ForgetPasswordMetaProps = {
    back: 'بازگشت',
    errorLabel: 'خطا:',
    successLabel: 'موفق!',
    successMessage: 'لطفاً صندوق ورودی ایمیل (و پوشه اسپم) خود را برای لینک بازنشانی رمز عبور بررسی کنید.',
    title: 'فراموشی رمز عبور',
    emailLabel: 'ایمیل',
    emailPlaceholder: 'you@example.com',
    sendResetLink: 'ارسال لینک بازنشانی'
}

export const ResetPasswordMeta: ResetPasswordMetaProps = {
    errorLabel: 'خطا:',
    successLabel: 'موفق!',
    title: 'بازنشانی رمز عبور',
    passwordLabel: 'رمز عبور',
    passwordPlaceholder: 'رمز عبور جدید',
    confirmPasswordLabel: 'تأیید رمز عبور',
    confirmPasswordPlaceholder: 'تأیید رمز عبور جدید',
    resetting: 'در حال بازنشانی...',
    resetButton: 'بازنشانی رمز عبور',
    invalidLinkError: 'لینک بازنشانی رمز عبور نامعتبر یا منقضی شده است.',
    passwordsDoNotMatch: 'رمزهای عبور مطابقت ندارند.',
    missingTokenError: 'توکن یا ایمیل موجود نیست. لطفاً از لینک ایمیل خود استفاده کنید.'
}

export const SignupMeta: SignupMetaProps = {
    checkEmailTitle: 'ایمیل خود را بررسی کنید',
    checkEmailMessage: 'ما یک لینک تأیید به آدرس ایمیل شما ارسال کرده‌ایم. لطفاً روی لینک کلیک کنید تا حساب خود را تأیید کنید.',
    checkEmailHint: 'ایمیل دریافت نکرده‌اید؟ پوشه اسپم خود را بررسی کنید. لینک تأیید پس از ۶۰ دقیقه منقضی می‌شود.',
    travelInfo: 'اگر قبلاً برنامه‌ریزی سفر دارید و می‌خواهید داوطلب شوید، لطفاً علاقه‌مندی خود را ثبت کنید. داوطلبی بر اساس ترتیبات شخصی است و تمام الزامات سفر، اقامت، ویزا و موارد مرتبط باید به طور مستقل ترتیب داده شود.',
    accountInfoTitle: 'اطلاعات حساب',
    emailPlaceholder: 'آدرس ایمیل',
    passwordPlaceholder: 'رمز عبور',
    rePasswordPlaceholder: 'تکرار رمز عبور',
    volunteerInfoTitle: 'اطلاعات داوطلب',
    firstNamePlaceholder: 'نام',
    lastNamePlaceholder: 'نام خانوادگی',
    selectGender: 'انتخاب جنسیت',
    male: 'مرد',
    female: 'زن',
    preferNotToSay: 'ترجیح می‌دهم نگویم',
    countryCodePlaceholder: 'کد کشور مثلاً: +98',
    phonePlaceholder: 'شماره تلفن',
    countryPlaceholder: 'کشور',
    jamatkhanaPlaceholder: 'جماعت‌خانه',
    familyOriginLabel: 'اصل و نسب خانوادگی',
    selectOrigin: 'انتخاب اصل و نسب',
    additionalDetailsTitle: 'جزئیات اضافی',
    ismaili: 'اسماعیلی',
    interFaithFamily: 'خانواده بین‌ادیانی',
    languagesLabel: 'زبان‌ها',
    supportNeedsPlaceholder: 'نیازهای پشتیبانی اضافی…',
    registerButton: 'ثبت‌نام',
    registering: 'در حال ثبت‌نام…',
    passwordsDoNotMatch: 'رمزهای عبور مطابقت ندارند.',
    faithStatusRequired: 'لطفاً اسماعیلی یا خانواده بین‌ادیانی را انتخاب کنید.',
    invalidDob: 'لطفاً یک تاریخ تولد معتبر وارد کنید.'
}

export const VerifyEmailMeta: VerifyEmailMetaProps = {
    title: 'تأیید ایمیل',
    verifying: 'در حال تأیید ایمیل شما...',
    successTitle: 'ایمیل با موفقیت تأیید شد!',
    successMessage: 'از شما برای ثبت‌نام به عنوان داوطلب برای بازدید انگلستان سپاسگزاریم.',
    reviewMessage: 'درخواست ثبت‌نام داوطلبانه شما در حال بررسی است.',
    approvalNotice: 'پس از تأیید ثبت‌نام شما توسط تیم ما، یک ایمیل اطلاع‌رسانی دریافت خواهید کرد.',
    travelInfo: 'اگر قبلاً برنامه‌ریزی سفر دارید و می‌خواهید داوطلب شوید، لطفاً علاقه‌مندی خود را ثبت کنید. داوطلبی بر اساس ترتیبات شخصی است و تمام الزامات سفر، اقامت، ویزا و موارد مرتبط باید به طور مستقل ترتیب داده شود.',
    backToLogin: 'بازگشت به ورود',
    backToSignup: 'بازگشت به ثبت‌نام',
    sending: 'در حال ارسال...',
    resendVerification: 'ارسال مجدد ایمیل تأیید',
    invalidLinkError: 'لینک تأیید نامعتبر است. لطفاً لینک موجود در ایمیل خود را بررسی کنید.'
}

export const HouseholdSelectionMeta: HouseholdSelectionMetaProps = {
    errorTitle: 'خطا',
    returnToLogin: 'بازگشت به ورود',
    title: 'انتخاب عضو خانواده',
    description: 'لطفاً انتخاب کنید که می‌خواهید به عنوان کدام عضو خانواده از پلتفرم استفاده کنید.',
    youBadge: 'شما',
    cancel: 'لغو',
    loadError: 'بارگذاری اعضای خانواده ناموفق بود. لطفاً دوباره وارد شوید.'
}

export const CheckInLoginFormMeta: CheckInLoginFormMetaProps = {
    errorLabel: 'خطا:',
    title: 'ورود برای اعلام حضور',
    usernameLabel: 'نام کاربری',
    usernamePlaceholder: 'نام کاربری خود را وارد کنید',
    passwordLabel: 'رمز عبور',
    passwordPlaceholder: 'رمز عبور خود را وارد کنید',
    loginButton: 'ورود'
}


export const ApprovedCountries = [
    'Austria',
    'Germany',
    'Italy',
    'Poland',
    'Denmark',
    'Finland',
    'Netherlands',
    'Norway',
    'Sweden',
    'Bulgaria',
    'Czech Republic',
    'Estonia',
    'Greece',
    'Hungary',
    'Latvia',
    'Lithuania',
    'Malta',
    'North Macedonia',
    'Romania',
    'Slovakia',
    'Slovenia',
    'North Cyprus',
    'Turkey',
    //'Türkiye',
]



export const EU_JAMAT_KHANA_OPTIONS = [
    'amsterdam',
    'bad salzuflen',
    'berlin',
    'bologna',
    'bosel',
    'bulgaria',
    'cologne',
    'copenhagen',
    'czech',
    'dresden',
    'eindhoven',
    'erfurt',
    'essen',
    'estonia',
    'frankfurt',
    'gothenburg',
    'graz',
    'greece',
    'hamburg',
    'helsinki',
    'hungary',
    'kassel',
    'krakow',
    'latvia',
    'leipzig',
    'linz',
    'lithuania',
    'ljungby',
    'malmo',
    'malta',
    'munich',
    'nicosia',
    'north macedonia',
    'orebro',
    'oslo',
    'romania',
    'rome',
    'rotterdam',
    'rzeszow',
    'slovakia',
    'slovenia',
    'stockholm',
    'stuttgart',
    'szczecin',
    'turkey',
    'umea',
    'vanersborg',
    'vienna',
    'warsaw',
    'wuppertal',
    'zevenaar',
];

export const GuidelineFormModalMeta: GuidelineFormModalMetaProps = {
    title: 'ایجاد دستورالعمل',
    nameLabel: 'نام',
    namePlaceholder: 'نام...',
    descriptionLabel: 'توضیحات',
    descriptionPlaceholder: 'توضیحات...',
    audienceLabel: 'چه کسی می‌تواند این دستورالعمل را ببیند؟',
    audienceAllOption: 'انتخاب همه',
    audienceServiceRecordOption: 'انتخاب جایگاه‌های داوطلبی',
    addModuleButton: 'افزودن محتوا',
    noModulesMessage: 'محتوایی موجود نیست',
    uploadButton: 'ذخیره دستورالعمل',
    uploadingLabel: 'در حال ذخیره...',
    cancelButton: 'لغو',
    submitButton: 'ارسال',
    submittingButton: 'در حال ارسال...'
}

export const AdminGuidelinesMeta: AdminGuidelinesMetaProps = {
    title: 'دستورالعمل‌ها',
    description: 'مدیریت دستورالعمل‌های مرجع برای داوطلبان',
    errorTitle: 'خطا',
    noGuidelinesMessage: 'هنوز دستورالعملی وجود ندارد',
    loadingText: 'در حال بارگذاری...'
}

export const VolunteerGuidelinesMeta: VolunteerGuidelinesMetaProps = {
    title: 'دستورالعمل‌ها',
    errorTitle: 'خطا',
    noGuidelinesMessage: 'دستورالعملی در دسترس نیست',
    documentsLabel: 'سند'
}

export const GuidelineDetailsMeta: GuidelineDetailsMetaProps = {
    backButtonLabel: 'بازگشت به دستورالعمل‌ها',
    errorTitle: 'خطا',
    notFoundMessage: 'دستورالعمل یافت نشد'
}

export const DirectorVolunteerMeta: DirectorVolunteerMetaProps = {
    title: "داوطلبان جماعت‌خانه شما",
    description: "مشاهده داوطلبان جماعت‌خانه شما"
}


